export const languageSpanish = {
    "formating": {
        "main": "Prompt Principal",
        "jailbreak": "Prompt Jailbreak",
        "chats": "Chats Anteriores",
        "lorebook": "Libro de Lore",
        "globalNote": "Nota Global",
        "authorNote": "Nota del Autor",
        "lastChat": "Último Chat",
        "description": "Descripción del Personaje",
        "personaPrompt": "Prompt de Persona",
        "plain": "Prompt Simple",
        "memory": "Supa/HypaMemoria",
        "postEverything": "Prompts Inyectados al Final"
    },
    "errors": {
        "toomuchtoken": "Error: El mínimo requerido de tokens es mayor que el Tamaño Máximo del Contexto.",
        "unknownModel": "Error: Modelo seleccionado desconocido",
        "httpError": "Error: error en la solicitud:",
        "noData": "Ese archivo no parece válido o sus datos están dañados.",
        "onlyOneChat": "Debe haber al menos un chat",
        "alreadyCharInGroup": "Ya hay un personaje con el mismo nombre en el grupo.",
        "noUserIcon": "Debes establecer tu icono primero.",
        "emptyText": "El texto está vacío.",
        "wrongPassword": "Contraseña incorrecta",
        "networkFetch": "Esto ocurre cuando la red es inestable o el servidor está caído.",
        "networkFetchWeb": "Esto puede ser un error de CORS. Esto solo ocurre al usar la versión web debido a las limitaciones del navegador. Intenta usar la versión local de escritorio u otra versión de Risuai.",
        "networkFetchPlain": "Esto puede ser un error de fetch simple. Intenta desactivar la opción de forzar fetch simple en la configuración.",
        "requestLogRemoved": "Este registro de solicitud ha sido eliminado.",
        "requestLogRemovedDesc": "Este registro de solicitud se elimina cuando el cliente se actualiza o recarga.",
        "vertexAuthError": "Faltan los detalles de autenticación de Vertex AI.",
        "coldStorageWriteFailed": "Error al escribir en almacenamiento frío. Sus datos de chat se han conservado.",
        "coldStorageVerifyFailed": "Error en la verificación del almacenamiento frío. Sus datos de chat se han conservado."
    },
    "showHelp": "Mostrar Ayuda",
    "help": {
        "model": "La opción de modelo es el modelo principal usado en el chat.",
        "submodel": "El Modelo Auxiliar es un modelo que se utiliza para analizar imágenes de emociones, auto sugerencias, etc. Se recomienda GPT-3.5.",
        "oaiapikey": "Clave API para OpenAI. Puedes obtenerla en https://platform.openai.com/account/api-keys",
        "mainprompt": "La opción de prompt principal establece el comportamiento predeterminado del modelo.",
        "jailbreak": "La opción de prompt jailbreak se activa cuando el interruptor jailbreak está activado en el personaje.",
        "globalNote": "Una nota que afecta fuertemente el comportamiento del modelo, también conocida como UJB. Funciona en todos los personajes.",
        "autoSuggest": "Prompts usados para generar opciones cuando se sugieren automáticamente respuestas al usuario.",
        "formatOrder": "Orden de formateo del prompt. Los bloques inferiores tienen más efecto en el modelo.",
        "forceUrl": "Si no está en blanco, la solicitud se enviará a la URL que hayas ingresado.",
        "tempature": "Valores más bajos hacen que el personaje siga los prompts de cerca, pero es más probable que responda como una máquina.\nValores más altos resultarán en un comportamiento creativo, pero la respuesta del personaje puede descomponerse más fácilmente.",
        "frequencyPenalty": "Valores más altos evitan el uso de palabras duplicadas en la respuesta, pero la respuesta del personaje puede descomponerse más fácilmente.",
        "presensePenalty": "Valores más altos evitan el uso de palabras duplicadas en todo el contexto, pero la respuesta del personaje puede descomponerse más fácilmente.",
        "sdProvider": "Proveedor para generación de imágenes.",
        "msgSound": "Reproduce un sonido *ding* cuando el personaje responde.",
        "charDesc": "Breve descripción del personaje. Esto afecta las respuestas del personaje.",
        "charFirstMessage": "Primer mensaje del personaje. Esto afecta altamente las respuestas del personaje.",
        "charNote": "Una nota que afecta fuertemente el comportamiento del modelo. Embebida en el personaje actual. También conocida como UJB.",
        "toggleNsfw": "Activa o desactiva el prompt jailbreak.",
        "lorebook": "El Libro de Lore es un diccionario creado por el usuario para la IA. La IA solo lo ve cuando hay una clave de activación en el contexto.",
        "loreName": "Nombre del lore. No afecta a la IA.",
        "loreActivationKey": "Si una de las claves de activación existe en el contexto, el lore se activará y el prompt se insertará. Separado por comas.",
        "loreorder": "Si el Orden de Inserción es más alto, afectará más al modelo, y será menos probable que se corte cuando haya muchos lores activados.",
        "bias": "Bias es un dato clave-valor que modifica la probabilidad de que aparezca una cadena.\nPuede ser de -100 a 100, los valores más altos serán más propensos a aparecer, y los valores más bajos serán menos propensos a aparecer. \nAdemás, si se establece en -101, funcionará como una 'palabra prohibida fuerte' para algunos modelos. \nAdvertencia: si el tokenizador es incorrecto, no funcionará correctamente.",
        "emotion": "La opción de Imágenes de Emoción muestra imágenes según la emoción del personaje, que se analiza a partir de la respuesta del personaje. Debes ingresar el nombre de la emoción como palabras *(como alegría, felicidad, miedo, etc.)*. La emoción nombrada **neutral** será la emoción predeterminada si existe. Deben ser más de 3 imágenes para que funcione correctamente.",
        "imggen": "Después de analizar el chat, aplica el prompt a {{slot}}.",
        "regexScript": "El Script Regex es un script personalizado que reemplaza la cadena que coincide de IN a OUT.\n\nHay cuatro opciones de tipo.\n\n- **Modificar Entrada (Input)** modifica la entrada del usuario\n\n- **Modificar Salida (Output)** modifica la respuesta del personaje\n\n- **Modificar Datos de Solicitud** modifica los datos actuales del chat cuando se envía.\n\n- **Modificar Visualización** solo modifica el texto cuando se muestra sin modificar los datos del chat.\n\nIN debe ser un regex sin Flags y sin barras en el inicio y el final.\n\nOUT es una cadena que puede incluir patrones de reemplazo. Estos son los patrones:\n\n- $$\n\n    - inserta $\n\n- $&\n\n    - inserta la subcadena coincidente.\n\n- $`\n\n    - inserta la porción de la cadena que precede a la subcadena coincidente.\n\n- $1\n\n    - inserta el primer grupo coincidente. Funciona con otros números como 2, 3...\n\n- $(nombre)\n\n    - inserta el grupo nombrado\n\nSi OUT comienza con **@@**, no reemplaza la cadena, pero en su lugar realiza un efecto especial si se encuentra la cadena coincidente.\n\n- @@emo (nombre de emoción)\n\n    - si el personaje está en modo Imágenes de Emoción, establece (nombre de emoción) como emoción y evita la predeterminada.",
        "experimental": "Esta es una característica experimental. Podría ser inestable.",
        "oogaboogaURL": "Si tu WebUI admite una versión anterior de la API, tu URL debería parecerse a *https:.../run/textgen*\n\nSi tu WebUI admite la nueva versión de la API, tu URL debería parecerse a *https://.../api/v1/generate* y usar el servidor API como host, y agregar --api a los argumentos.",
        "exampleMessage": "Conversaciones de ejemplo que afectan la respuesta del personaje. No usa tokens permanentemente.\n\nFormato de ejemplo de conversaciones:\n\n```\n<START>\n{{usuario}}: hola\n{{char}}: hola\n<START>\n{{usuario}}: hola\nHaruhi: hola\n```\n\n```<START>``` Marca el comienzo de una nueva conversación.",
        "creatorQuotes": "Nota que aparece en la parte superior del primer mensaje. Se utiliza para informar a los usuarios sobre este personaje. No va en el prompt.",
        "systemPrompt": "Un prompt que reemplaza el prompt principal en la configuración si no está en blanco.",
        "chatNote": "Una nota que afecta fuertemente el comportamiento del modelo. Embebida en el chat actual. También conocida como memoria o ujb.",
        "personality": "Una breve descripción sobre la personalidad del personaje. \n\n**No se recomienda usar esta opción. Descríbelo en la descripción del personaje en su lugar.**",
        "scenario": "Una breve descripción sobre el escenario del personaje. \n\n**No se recomienda usar esta opción. Descríbelo en la descripción del personaje en su lugar.**",
        "utilityBot": "Cuando está activado, ignora el prompt principal, jailbreak y otros prompts. Se utiliza para bots diseñados para utilidades, no para juegos de rol.",
        "loreSelective": "Si el modo Selectivo está activado, tanto la Clave de Activación como la Clave Secundaria deben coincidir para activar el lore.",
        "loreRandomActivation": "Si la Condición de Probabilidad está habilitada, si se cumplen todas las demás condiciones del lore, el lore se activará con una probabilidad establecida por 'Probabilidad' cada vez que se envíe un chat.",
        "additionalAssets": "Activos adicionales para mostrar en tu chat. \n\n - usa `{{raw::<nombre del activo>}}` para usar como ruta.\n - usa `{{image::<nombre del activo>}}` para usar como imagen\n - usa `{{video::<nombre del activo>}}` para usar como video\n - usa `{{audio::<nombre del activo>}}` para usar como audio\n    - se recomienda poner en HTML de Fondo",
        "superMemory": "SuperMemoria hace que tu personaje memorice más dando datos resumidos a la IA.\n\nEl modelo de SuperMemoria es un modelo que resume ese texto. Se recomienda Davinci, y no se recomienda usar modelos auxiliares a menos que sea un modelo no filtrado con más de 2000 tokens y con una gran habilidad de resumen.\n\nEl Prompt de SuperMemoria decide qué prompt se debe enviar para resumir. Si lo dejas en blanco, usará el prompt predeterminado. Se recomienda dejarlo en blanco.\n\nDespués de configurarlo todo, puedes habilitarlo en la configuración de un personaje.",
        "replaceGlobalNote": "Si no está en blanco, reemplaza la nota global actual con esta.",
        "backgroundHTML": "Datos de Markdown/HTML que se inyectarán en el fondo de la pantalla de chat.\n\n También puedes usar activos adicionales. por ejemplo, puedes usar `{{audio::<nombre del activo}}` para música de fondo.\n\n Además, puedes usar estos con activos adicionales:\n - `{{bg::<nombre del activo>}}`: inyecta el fondo como activo",
        "additionalText": "El texto que se agregará a la Descripción del Personaje solo cuando la IA crea que es necesario, por lo que puedes poner textos largos aquí. Sepáralo con doble salto de línea.",
        "charjs": "Un código JavaScript que se ejecutará con el personaje. Por ejemplo, puedes consultar `https://github.com/kwaroran/Risuai/blob/main/src/etc/example-char.js` ACTUALMENTE NO SE RECOMIENDA USAR DEBIDO A PROBLEMAS DE SEGURIDAD. EXPORTAR NO INCLUIRÁ ESTO.",
        "romanizer": "Romanizador es un complemento que convierte caracteres no romanos a caracteres romanos para reducir tokens al usar caracteres no romanos al solicitar datos. Esto puede resultar en una respuesta diferente del modelo original. No se recomienda usar este complemento al usar caracteres romanos en el chat.",
        "inlayImages": "Si está habilitado, las imágenes podrían incrustarse en el chat y las IA pueden verlas si lo admiten.",
        "metrica": "Metric Systemizer es un complemento que convierte métricas a unidades imperiales al solicitar datos, y viceversa en la respuesta para mostrar al usuario el sistema métrico mientras usa el imperial para el rendimiento. No se recomienda usar este complemento al usar unidades imperiales en el chat.",
        "lorePlus": "LoreBook+ es una característica experimental que utiliza vectordb en lugar de solo coincidencia de cadenas para una mejor experiencia de creación de bots y un mejor rendimiento de coincidencia.",
        "topP": "Top P es un umbral de probabilidad para el muestreo de núcleo. El modelo considera los resultados de los tokens con la masa de probabilidad top_p.",
        "openAIFixer": "OpenAI Fixer es un complemento que soluciona algunos de los problemas de OpenAI.",
        "sayNothing": "Si está habilitado, ingresará 'no decir nada' cuando no se haya ingresado ninguna cadena.",
        "showUnrecommended": "Si está habilitado, mostrará configuraciones no recomendadas y obsoletas. NO SE RECOMIENDA usar estas configuraciones.",
        "imageCompression": "Si está habilitado, comprimirá las imágenes al exportar el personaje. Si las imágenes animadas no funcionan, intenta desactivar esta opción.",
        "useExperimental": "Si está habilitado, mostrará algunas características experimentales.",
        "forceProxyAsOpenAI": "Si está habilitado, forzará el uso del formato OpenAI al usar un proxy inverso.",
        "forcePlainFetch": "Si está habilitado, usará la API de fetch del navegador en lugar de la solicitud HTTP nativa. Esto puede causar errores de CORS.",
        "autoFillRequestURL": "Si está habilitado, completará automáticamente la URL de la solicitud para que coincida con el modelo actual.",
        "chainOfThought": "Si está habilitado, agregará el prompt de cadena de pensamientos al prompt.",
        "gptVisionQuality": "Esta opción se utiliza para establecer la calidad del modelo de detección de imágenes. Cuanto mayor sea la calidad, más precisa será la detección, pero se usarán más tokens.",
        "genTimes": "Esta opción se utiliza para establecer el número de respuestas a generar en los modelos compatibles. Otras que no sean la primera respuesta actuarán como un reroll en caché. Esto puede reducir el costo del modelo, pero también puede aumentarlo si lo usas sin reroll.",
        "requestretrys": "Esta opción se utiliza para establecer el número de reintentos de solicitud cuando la solicitud falla.",
        "chatLoadInitialPages": "Cantidad de mensajes recientes que se renderizan al abrir una pantalla de chat. Los valores más altos muestran más historial de inmediato, pero pueden hacer más pesada la apertura de chats largos.",
        "chatLoadAdditionalPages": "Cantidad de mensajes antiguos que se renderizan cada vez que te desplazas hasta arriba. Los valores más altos reducen las cargas repetidas, pero pueden hacer más pesada cada carga.",
        "emotionPrompt": "Esta opción se utiliza para establecer el prompt que se usa para detectar la emoción. Si está en blanco, usará el prompt predeterminado.",
        "removePunctuationHypa": "Si está habilitado, eliminará la puntuación antes de ejecutar HypaMemory.",
        "additionalParams": "Parámetros adicionales que se agregarán al cuerpo de la solicitud. Si deseas excluir algunos parámetros, puedes poner `{{none}}` en el valor. Si deseas agregar un encabezado en lugar de un cuerpo, puedes poner `header::` delante de la clave, como `header::Authorization`. Si deseas el valor como JSON, puedes poner `json::` delante del valor, como `json::{\"key\":\"value\"}`. De lo contrario, el tipo del valor se determinará automáticamente.",
        "antiClaudeOverload": "Si ocurre sobrecarga de Claude, Risuai intentará evitarla continuando con el mismo prompt, haciéndolo menos probable que ocurra. Funciona solo para respuestas transmitidas. Esto podría no funcionar para endpoints de API no oficiales.",
        "triggerScript": "Trigger Script es un script personalizado que se ejecuta cuando se cumple una condición. Se puede usar para modificar los datos del chat, ejecutar un comando, cambiar variables, etc. El tipo depende de cuándo se activa. También puede ejecutarse mediante botones, que se pueden usar con {{button::Display::TriggerName}}, o botones HTML con el atributo `risu-trigger=\"<TriggerName>\"`.",
        "autoContinueChat": "Si está habilitado, intentará continuar el chat si no termina con un signo de puntuación. NO USES ESTO CON IDIOMAS QUE NO USAN SIGNOS DE PUNTUACIÓN.",
        "combineTranslation": "Si está habilitado, el texto que es una oración pero está separado por etiquetas HTML se combinará y se traducirá, luego se volverá a aplicar el script de Modificar Visualización a la respuesta traducida.\nEsto ayuda al traductor a realizar la traducción correcta.\nSi la interfaz de usuario se vuelve extraña cuando activas esta opción, desactiva la opción e informa sobre el problema.",
        "dynamicAssets": "Si está habilitado, si no se encuentra el nombre del activo al procesar datos, intentará encontrar el nombre del activo más cercano usando la búsqueda de vectores y reemplazarlo con el nombre del activo más cercano.",
        "dynamicAssetsEditDisplay": "Si está habilitado, los activos dinámicos se aplicarán también en la etapa de Modificar Visualización. Sin embargo, esto puede causar problemas de rendimiento.",
        "nickname": "El apodo se utilizaría en {{char}} o <char> en el chat en lugar del nombre del personaje si está configurado.",
        "useRegexLorebook": "Si está habilitado, usará regex para la búsqueda en el lorebook, en lugar de coincidencia de cadenas. Usa el formato /regex/flags.",
        "customChainOfThought": "Advertencia: el interruptor de cadena de pensamientos ya no se recomienda. Pon el prompt de cadena de pensamientos en otras entradas de prompt en su lugar.",
        "customPromptTemplateToggle": "Aquí puedes definir tus propios interruptores de prompt. Usa el formato `<variable del interruptor>=<nombre del interruptor>`, separado por nueva línea. Por ejemplo, `cot=Toggle COT`. Puedes usar estos interruptores en el prompt usando `{{getglobalvar::toggle_<variable del interruptor>}}`. Como `{{getglobalvar::toggle_cot}}`.",
        "defaultVariables": "Aquí puedes definir tus propias variables predeterminadas. Usa el formato `<nombre de la variable>=<valor de la variable>`, separado por nueva línea. Por ejemplo, `name=Risuai`, que luego se puede usar con scripts de activación y variables CBS como `{{getvar::A}}`, `{{setvar::A::B}}` o `{{? $A + 1}}`. Si la variable predeterminada del template del prompt y la variable predeterminada del personaje tienen el mismo nombre, se usará la variable predeterminada del personaje.",
        "lowLevelAccess": "Si está habilitado, permitirá el acceso a funciones que requieren altas potencias de computación y ejecutar el modelo de IA a través de activadores en el personaje. No habilites esto a menos que realmente necesites estas características.",
        "triggerLLMPrompt": "Un prompt que se enviará al modelo. Puedes usar múltiples turnos y roles usando `@@role usuario`, `@@role sistema`, `@@role asistente`. Por ejemplo, \n```\n@@role sistema\nresponde como hola\n@@role asistente\nhola\n@@role usuario\nhola\n```",
        "legacyTranslation": "Si está habilitado, usará el método de traducción antiguo, que preprocesa Markdown y citas antes de las traducciones en lugar de postprocesar después de las traducciones.",
        "luaHelp": "Puedes usar scripts Lua como script de activación. Puedes definir funciones onInput, onOutput, onStart. onInput se llama cuando el usuario envía un mensaje, onOutput se llama cuando el personaje envía un mensaje, onStart se llama cuando comienza el chat. Para más información, consulta la documentación.",
        "openAIFlexProcessing": "Las respuestas OpenAI Flex pueden ser más lentas que las respuestas normales, pero se obtienen a un precio más bajo (precio de Batch API). Este interruptor solo se aplica a solicitudes oficiales de OpenAI Chat Completions.",
        "claudeCachingExperimental": "El almacenamiento en caché en Claude es una característica experimental que puede reducir el costo del modelo, pero también puede aumentarlo si lo usas sin reroll. Dado que es una característica experimental, puede ser inestable y el comportamiento puede cambiar en el futuro.",
        "urllora": "Puedes usar el enlace de descarga directa del archivo del modelo. Puedes crear una URL directa desde Google Drive o usar una URL de Civitai, copiar el AIR (se ve como `urn:air:flux1:lora:civitai:180891@776656` o simplemente `civitai:180891@776656`) y pegarlo.",
        "v2GetAlertSelect": "Las opciones se separan por el carácter | (barra vertical).",
        "v2RegexTest": "Devuelve 1 si la expresión regular coincide, 0 si no coincide.",
        "v2Calculate": "Evalúa expresiones matemáticas con soporte para aritmética básica (+, -, *, /, %, ^), operadores de comparación (<, >, <=, >=, =, !=), operadores lógicos (&&, ||, !), paréntesis para precedencia y sustitución de variables usando el formato $nombreVariable. Las variables se convierten automáticamente a números (predeterminado a 0 si es inválido).",
        "namespace": "Namespace es un identificador único para el módulo. Se utiliza para prevenir conflictos entre módulos y para la interacción de presets, otros módulos, etc. Si no estás seguro de qué poner, déjalo en blanco.",
        "moduleIntergration": "Puedes habilitar módulos poniendo el namespace del módulo en las secciones de integración de módulos. Si deseas habilitar múltiples módulos, puedes separarlos por comas. Por ejemplo, `modulo1,modulo2,modulo3`. Esto es para usuarios avanzados que desean variar el uso de módulos por presets.",
        "customCSS": "CSS personalizado para estilos. También puedes desactivarlo/activarlo presionando (Ctrl + .) si algo sale mal.",
        "betaMobileGUI": "Si está habilitado, usará la GUI móvil beta en pantallas pequeñas (menos de 800px). Requiere recargar.",
        "unrecommended": "Esta es una configuración no recomendada. No se recomienda usar esta configuración.",
        "jsonSchema": "Este es un esquema JSON que se enviará al modelo de IA si el modelo admite JSON Schema.\n\nSin embargo, dado que JSON Schema es difícil de aprender, en Risuai puedes usar un subconjunto de la interfaz TypeScript en lugar de JSON Schema. Risuai lo convertirá en tiempo de ejecución. Por ejemplo, si quieres enviar un JSON como este:\n\n```js\n{\n  \"name\": \"Risuai\", //name must be Risuai,\n  \"age\": 1, //age must be number,\n  \"icon\": \"slim\", //icon must be 'slim' or 'rounded'\n  \"thoughts\": [\"Good View!\", \"Lorem\"] //thoughts must be array of strings\n}\n```\n\nPuedes poner esta interfaz TypeScript:\n\n```typescript\ninterface Schema {\n  name: string;\n  age: number;\n  icon: 'slim'|'rounded'\n  thoughts: string[]\n}\n```\n\nEl nombre de la interfaz no importa. Para más información, consulta la documentación de TypeScript (https://www.typescriptlang.org/docs/handbook/interfaces.html), y para verificar qué subconjunto de TypeScript es compatible, consulta a continuación.<details><summary>Subconjunto de TypeScript Compatible</summary>\n\nLos tipos compatibles son `boolean`, `number`, `string`, `Array`. Tipos avanzados como tipos unitarios, tipos de intersección, tipos de unión, opcionales, tipos literales, etc., no son compatibles excepto en estos casos:\n\n        - Array de tipos primitivos: (ej. `string[]`, `Array<boolean>)`\n        - Tipos unitarios entre cadenas: (ej. `'slim'|'rounded'`).\n\n        Las propiedades deben estar una por línea. Si hay múltiples propiedades en una línea, arrojará un error. Las propiedades y el nombre de la interfaz deben estar solo en caracteres latinos, en el rango ASCII. El nombre de las propiedades no debe estar entre comillas o comillas dobles. No se admite anidamiento dentro de la interfaz. No se permite poner `{` o `}` en la línea donde se definen las propiedades. Si deseas usar tipos más avanzados, usa JSON Schema en su lugar.\n        </details>",
        "strictJsonSchema": "Si está habilitado, seguirá estrictamente el esquema proporcionado para JSON en algunos modelos. Si está deshabilitado, puede ignorar el esquema JSON.",
        "extractJson": "Si no está en blanco, extraerá datos JSON específicos de la respuesta. Por ejemplo, si deseas extraer `response.text[0]` en la respuesta `{\"response\": {\"text\": [\"hello\"]}}`, puedes poner `response.text.0`.",
        "translatorNote": "Aquí puedes agregar un prompt de traducción único para cada personaje. Esta opción solo se aplica al usar el modelo Ax. para traducción. Para aplicarlo, incluye `{{slot::tnote}}` en la configuración de idioma. No funciona en chats grupales.",
        "groupInnerFormat": "Esto define un formato que se usa en el chat grupal para personajes que no son el hablante. Si no está en blanco, usará este formato en lugar del formato predeterminado. Si `Rol de Otro Bot en Grupo` es `assistant`, también se aplicará al hablante.",
        "groupOtherBotRole": "Esto define un rol que se usa en el chat grupal para personajes que no son el hablante.",
        "chatHTML": "Un HTML que se insertará como cada chat.\n\nPuedes usar CBS y etiquetas especiales.\n- `<risutextbox>`: un cuadro de texto que se usaría para renderizar texto\n- `<risuicon>`: un icono para usuario o asistente\n- `<risubuttons>`: botones de icono para editar chat, traducciones, etc.\n- `<risugeninfo>`: botón de información de generación.",
        "systemContentReplacement": "El formato de prompt que reemplaza el prompt del sistema si el modelo no admite prompt del sistema.",
        "systemRoleReplacement": "El rol que reemplaza el rol del sistema si el modelo no admite rol del sistema.",
        "summarizationPrompt": "El prompt que se utiliza para resumir. Si está en blanco, utilizará el prompt predeterminado. También puedes usar el formato ChatML con {{slot}} para los datos del chat.",
        "translatorPrompt": "El prompt que se utiliza para la traducción. Si está en blanco, utilizará el prompt predeterminado. También puedes usar el formato ChatML con {{slot}} para el idioma de destino, {{solt::content}} para el contenido y {{slot::tnote}} para la nota del traductor.",
        "translateBeforeHTMLFormatting": "Si está habilitado, traducirá el texto antes de los scripts Regex y el formateo HTML. Esto podría reducir los tokens pero podría romper el formateo.",
        "autoTranslateCachedOnly": "Si está habilitado con la opción de Traducción Automática activada, traducirá automáticamente solo los mensajes que el usuario haya traducido previamente.",
        "presetChain": "Si no está en blanco, el preset cambiará y se aplicará aleatoriamente cada vez que el usuario envíe un mensaje en la lista de presets en esta entrada. La lista de presets debe estar separada por comas, por ejemplo, `preset1,preset2`.",
        "legacyMediaFindings": "Si está habilitado, usará el método antiguo para encontrar activos multimedia, sin usar el algoritmo de búsqueda adicional.",
        "comfyWorkflow": "Pon el flujo de trabajo API de ComfyUI. Puedes obtener tu flujo de trabajo API en ComfyUI presionando el botón 'Workflow > Export (API)'. También debes poner {{risu_prompt}} en tu texto de flujo de trabajo. El {{risu_prompt}} será reemplazado por el prompt proporcionado por Risu.",
        "automaticCachePoint": "Crea automáticamente un punto de caché después de que termina el chat, si el punto de caché no existe.",
        "experimentalChatCompressionDesc": "Comprime los datos de chat no utilizados y los guarda en un archivo separado. Esto reduce en gran medida el tamaño de los datos del chat y mejora en gran medida el rendimiento, sin embargo, es experimental y puede ser inestable, causando problemas en la función de respaldo y más.",
        "promptInfoInsideChatDesc": "Cuando está habilitado, almacena información del preset de prompt en los metadatos del chat. Los datos almacenados incluyen el nombre del preset, los interruptores activos y el texto del prompt. Esto puede aumentar ligeramente el tiempo de procesamiento y el uso de almacenamiento.",
        "autoAdjustSchema": "Cuando está habilitado, ajustará automáticamente el esquema JSON para la Salida Dinámica.",
        "dynamicMessages": "Cuando está habilitado, permitirá al asistente enviar múltiples mensajes seguidos, en lugar de uno a la vez.",
        "dynamicMemory": "Cuando está habilitado, el asistente tomará notas de memoria en el tiempo de respuesta. Se requiere prompting adicional para utilizar esta característica.",
        "dynamicResponseTiming": "Cuando está habilitado, ajustará el tiempo de respuesta dinámicamente.",
        "dynamicRequest": "Cuando está habilitado, solicitará al modelo en un momento aleatorio sin esperar la entrada del usuario.",
        "settingsCloseButtonSize": "Ajusta el tamaño del botón de cerrar (X) en la esquina superior derecha de la ventana de configuración. El valor predeterminado es 24.",
        "showTypingEffect": "Cuando está habilitado, mostrará un indicador de escritura mientras el asistente está generando una respuesta.",
        "dynamicOutputPrompt": "Cuando está habilitado, la información del esquema se incluirá en la solicitud.",
        "realmDirectOpen": "Si está habilitado, al hacer clic en un personaje en la vista previa de RisuRealm se abrirá directamente la descripción del personaje.",
        "openRouterProviderOrder": "El orden de los proveedores a usar, el primer proveedor se usará primero, si el proveedor no está disponible, usará el siguiente proveedor. Ver detalles en https://openrouter.ai/docs/guides/routing/provider-selection#ordering-specific-providers",
        "openRouterProviderOnly": "Solo usar los proveedores en esta lista, si todos los proveedores no están disponibles, la solicitud fallará. Ver detalles en https://openrouter.ai/docs/guides/routing/provider-selection#allowing-only-specific-providers",
        "openRouterProviderIgnore": "Ignorar los proveedores en esta lista, si todos los proveedores son ignorados, la solicitud fallará. Ver detalles en https://openrouter.ai/docs/guides/routing/provider-selection#ignoring-providers",
        "additionalPrompt": "Texto que se agrega al final del Prompt Principal cuando el Preprocesamiento de Prompt está habilitado. El valor predeterminado es 'The assistant must act as {{char}}. user is {{user}}.' Esto ayuda a establecer el contexto básico del juego de roles.",
        "hideAllImagesDesc": "Oculta los iconos de bots, recursos de imágenes de bots y portadas de RisuRealm.",
        "embedding": "El modelo de incrustación (embedding) se utiliza para la búsqueda de similitud en múltiples características:\n\n- **Memoria a Largo Plazo**: HypaV2, HypaV3, Memoria Hanurai y SupaMemory (con HypaMemory habilitado)\n- **Texto Adicional**: Coincidencia de información adicional del personaje basada en el contexto\n- **Activos Dinámicos**: Encontrar nombres de activos similares cuando no se encuentra una coincidencia exacta\n- **Imágenes de Emoción**: Cuando el método de Emoción está configurado en 'embedding'\n- **Scripts de Activación**: Condiciones de similitud en scripts de activación\n- **Archivos Adjuntos**: Búsqueda dentro de archivos adjuntos PDF/TXT/XML\n- **Playground**: Pruebas de incrustación en Playground",
        "enableScrollToActiveChar": "Si está habilitado, pulsar la tecla de acceso rápido o mantener presionada la tecla Ctrl mientras se arrastra un personaje desplazará la vista hasta el personaje activo. Las carpetas se abrirán automáticamente si están cerradas."
    },
    "setup": {
        "chooseProvider": "Elige Proveedor de IA",
        "openaikey": "OpenAI con Clave API (Recomendado)",
        "openaiProxy": "Proxy Inverso de OpenAI",
        "setupmodelself": "Otros / Lo configuraré yo mismo",
        "inputApiKey": "Ingresa la Clave API Aquí",
        "apiKeyhelp": "Puedes obtener la clave API en: ",
        "setupSelfHelp": "Configúralo tú mismo en la configuración, después de que termine la pantalla de bienvenida.",
        "theme": "Selecciona tu tema",
        "themeDescWifulike": "No apto para móviles",
        "themeDescWifuCut": "Apto para móviles",
        "themeDescClassic": "Apto para todos los dispositivos",
        "texttheme": "Selecciona el color del texto",
        "inputName": "Por último, ingresa tu apodo.",
        "welcome": "¡Bienvenido a Risuai! Aquí te guiaré para configurarlo. Primero, ¿cómo puedo llamarte?",
        "welcome2": "Hola {username}! Antes de empezar, te haré algunas preguntas. Puedes cambiar estas configuraciones más tarde en la configuración.\n\nPrimero selecciona el proveedor de IA.",
        "openRouterProvider": "OpenRouter tiene muchos modelos, algunos de ellos sin filtro y algunos gratuitos, pero no es tan bueno como OpenAI.",
        "hordeProvider": "Horde es un proveedor gratuito, pero el tiempo de respuesta es largo y la calidad es baja.",
        "setProviderLater": "Hay otros proveedores, pero puedes configurarlo más tarde en la configuración. selecciona esto si deseas configurarlo más tarde.",
        "setupOpenAI": "Para usar OpenAI, necesitas obtener una clave API. \n1. ve a https://beta.openai.com/ \n2. inicia sesión con tu cuenta \n3. ve a https://beta.openai.com/account/api-keys \n4. haz clic en 'Crear Nueva Clave API' y nombra tu clave como quieras. \n5. copia la clave en el sitio web.\n6. regresa a Risuai\n7. pégala y haz clic en el botón enviar.",
        "setupClaude": "Para usar Claude, necesitas obtener una clave API.",
        "setupClaudeSteps": [
            "Ve a esta URL e inicia sesión como Google",
            "Ingresa tu información y haz clic en 'Continuar'",
            "En la página de organización, simplemente ingresa cualquier nombre solo en el primer cuadro y haz clic en 'Crear cuenta'",
            "Presiona el botón 'Comprar créditos'",
            "Presiona el botón 'Completar configuración'",
            "Ingresa tal como en la imagen de arriba, excepto la sección de país, donde debes ingresar tu país. Luego presiona 'Continuar'",
            "Agrega tu método de pago y presiona 'Continuar'",
            "Después de que se haya registrado el pago, presiona 'Agregar fondos' y agrega fondos. Puedes agregar un mínimo de 5$, o puedes configurar la recarga automática.",
            "Después de agregar fondos, ve a la página del panel y presiona el botón 'Obtener claves API'",
            "Presiona el botón 'Crear clave API'",
            "Ingresa tal como en la imagen de arriba y presiona 'Agregar'",
            "Copia la clave, pégala aquí y envíala."
        ],
        "setupOpenRouter": "Para usar OpenRouter, necesitas obtener una clave API. \n1. ve a https://openrouter.ai/keys\n2. haz clic en 'Crear Clave'\n3. establece el nombre de la clave como quieras.\n4. copia la clave en el sitio web\n5. regresa a Risuai\n6. pégala y haz clic en el botón enviar.",
        "allDone": "¡Todo listo! por favor, espera un momento.",
        "setupLaterMessage": "¡Bienvenido {username}! ¿Quieres que te guíe para configurar o lo harás tú mismo?",
        "setupMessageOption1": "Guíame para configurar",
        "setupMessageOption1Desc": "Recomendado para nuevos usuarios",
        "setupMessageOption2": "Lo configuraré yo mismo",
        "claudeDesc": "Claude es un modelo de IA creado por Anthropic, competidor de OpenAI. Es mejor que GPT si quieres usarlo en otros idiomas además del inglés.",
        "openAIDesc": "OpenAI GPT es un modelo de IA de alta calidad, pero es de pago y filtrado, y débil en otros idiomas que no sean inglés.",
        "chooseChatType": "¡Genial! Ahora selecciona el idioma del chat.",
        "chooseChatTypeOption1": "Todo en Inglés",
        "chooseChatTypeOption1Desc": "Esto hará que la IA use inglés y entrada/salida en inglés. Recomendado para hablantes de inglés.",
        "chooseChatTypeOption2": "Procesamiento en Inglés",
        "chooseChatTypeOption2Desc": "Esto hará que la IA use inglés internamente, pero la entrada/salida estará en tu idioma. Recomendado para hablantes no ingleses.",
        "chooseChatTypeOption3": "Sin Idioma Enfocado",
        "chooseChatTypeOption3Desc": "Esto hará que la IA use tu idioma internamente, pero esto podría reducir la calidad.",
        "chooseCheapOrMemory": "Por cierto, ¿prefieres memoria o economía?",
        "chooseCheapOrMemoryOption1": "Memoria",
        "chooseCheapOrMemoryOption1Desc": "Esto hará que la IA recuerde más, pero será bastante costoso.",
        "chooseCheapOrMemoryOption2": "Económico",
        "chooseCheapOrMemoryOption2Desc": "Esto hará que la IA recuerde menos, pero será más barato.",
        "chooseCheapOrMemoryOption3": "Equilibrado",
        "chooseCheapOrMemoryOption3Desc": "Esto hará que la IA recuerde más que en económico, pero menos que en memoria.",
        "chooseCheapOrMemoryOption4": "Ilimitado",
        "chooseCheapOrMemoryOption4Desc": "Esto hará que la IA recuerde casi todo, pero será muy costoso.",
        "finally": "Finalmente, ¿quieres habilitar herramientas avanzadas?",
        "finallyOption1": "Sí",
        "finallyOption1Desc": "Esto habilitará herramientas avanzadas, pero hará que la interfaz de usuario sea más compleja. Recomendado para usuarios avanzados.",
        "finallyOption2": "No",
        "finallyOption2Desc": "Esto deshabilitará las herramientas avanzadas y hará que la interfaz de usuario sea más simple. Recomendado para nuevos usuarios.",
        "igpPrompt": "Si el Prompt IGP no está en blanco, se ejecutará después de la solicitud del modelo principal, después de la ejecución del modelo principal, como un modelo de emoción, agregando el resultado después de la respuesta del modelo principal."
    },
    "triggerCategories": {
        "Special": "Especial",
        "Control": "Control",
        "Chat": "Chat",
        "Low Level": "Bajo Nivel",
        "Alert": "Alerta",
        "Lorebook V2": "Libro de Lore V2",
        "String": "Cadena",
        "Data": "Datos",
        "Array": "Matriz",
        "Others": "Otros",
        "Deprecated": "Obsoleto"
    },
    "triggerDesc": {
        "v2Header": "Encabezado",
        "v2HeaderDesc": "Encabezado",
        "v2If": "Si",
        "v2IfDesc": "Si {{source}} {{condition}} {{target}}",
        "v2Else": "Sino",
        "v2ElseDesc": "Sino",
        "v2EndIndent": "Fin de Sangría",
        "v2EndIndentDesc": "Fin de Sangría",
        "v2SetVar": "Establecer Variable",
        "v2SetVarDesc": "Establecer Variable {{var}} {{operator}} {{value}}",
        "v2Loop": "Bucle Infinito",
        "v2LoopDesc": "Bucle Infinito",
        "v2BreakLoop": "Romper Bucle",
        "v2BreakLoopDesc": "Romper Bucle",
        "v2RunTrigger": "Ejecutar Trigger",
        "v2RunTriggerDesc": "Ejecutar Trigger {{target}}",
        "v2ConsoleLog": "Registro de Consola",
        "v2ConsoleLogDesc": "Registro de Consola {{source}}",
        "v2StopTrigger": "Detener Trigger",
        "v2StopTriggerDesc": "Detener Trigger",
        "v2CutChat": "Cortar Chat",
        "v2CutChatDesc": "Cortar Chat desde {{start}} hasta {{end}}",
        "v2ModifyChat": "Modificar Chat",
        "v2ModifyChatDesc": "Modificar Chat en índice {{index}} con {{value}}",
        "v2SystemPrompt": "Agregar Prompt del Sistema",
        "v2SystemPromptDesc": "Agregar Prompt del Sistema en {{location}} con {{value}}",
        "v2Impersonate": "Enviar Chat",
        "v2ImpersonateDesc": "Enviar Chat como {{role}} con {{value}}",
        "v2Command": "Ejecutar Comando",
        "v2CommandDesc": "Ejecutar comando con {{value}}",
        "v2SendAIprompt": "Enviar Prompt de IA",
        "v2SendAIpromptDesc": "Enviar Prompt de IA",
        "v2ImgGen": "Generación de Imagen",
        "v2ImgGenDesc": "Generar imagen desde {{value}}, negativo desde {{negValue}} => {{outputVar}}",
        "v2CheckSimilarity": "Comprobar Similitud",
        "v2CheckSimilarityDesc": "Comprobar similitud entre {{source}} y {{value}} => {{outputVar}}",
        "v2RunLLM": "Ejecutar Modelo",
        "v2RunLLMDesc": "Enviar solicitud al modelo desde {{value}} => {{outputVar}}",
        "v2ShowAlert": "Mostrar Alerta",
        "v2ShowAlertDesc": "Mostrar alerta con {{value}}",
        "v2ExtractRegex": "Extraer Regex",
        "v2ExtractRegexDesc": "Extraer texto de {{value}} con regex {{regexType}} {{regex}} y flags {{flagsType}} {{flags}}, luego guardar resultado como {{resultType}} {{result}} => {{outputVar}}",
        "v2RegexTest": "Prueba Regex",
        "v2RegexTestDesc": "Probar {{value}} con regex {{regex}} y flags {{flags}} => {{outputVar}}",
        "v2GetLastMessage": "Obtener Último Mensaje",
        "v2GetLastMessageDesc": "Obtener Último Mensaje => {{outputVar}}",
        "v2GetMessageAtIndex": "Obtener Mensaje en Índice",
        "v2GetMessageAtIndexDesc": "Obtener Mensaje en Índice {{index}} => {{outputVar}}",
        "v2GetMessageCount": "Obtener Recuento de Mensajes",
        "v2GetMessageCountDesc": "Obtener Recuento de Mensajes => {{outputVar}}",
        "v2GetLorebook": "Obtener Libro de Lore",
        "v2GetLorebookDesc": "Obtener Libro de Lore llamado {{target}} => {{outputVar}}",
        "v2GetLorebookCount": "Obtener Recuento de Libro de Lore",
        "v2GetLorebookCountDesc": "Obtener Recuento de Libro de Lore => {{outputVar}}",
        "v2GetLorebookEntry": "Obtener Entrada de Libro de Lore",
        "v2GetLorebookEntryDesc": "Obtener Libro de Lore con índice {{index}} => {{outputVar}}",
        "v2SetLorebookActivation": "Establecer Activación de Libro de Lore",
        "v2SetLorebookActivationDesc": "Establecer estado de activación del Libro de Lore con índice {{index}} a {{value}}",
        "v2GetLorebookIndexViaName": "Obtener Índice de Libro de Lore por Nombre",
        "v2GetLorebookIndexViaNameDesc": "Obtener Índice de Libro de Lore por Nombre {{name}} => {{outputVar}}",
        "v2ModifyLorebook": "Modificar Libro de Lore",
        "v2ModifyLorebookDesc": "Modificar Libro de Lore llamado {{target}} con {{value}}",
        "v2LoopNTimes": "Bucle N Veces",
        "v2LoopNTimesDesc": "Bucle {{value}} Veces",
        "v2Random": "Aleatorio",
        "v2RandomDesc": "Aleatorio desde {{min}} hasta {{max}} => {{outputVar}}",
        "v2GetCharAt": "Obtener Carácter en Índice",
        "v2GetCharAtDesc": "Obtener Carácter en Índice {{index}} de {{source}} => {{outputVar}}",
        "v2GetCharCount": "Obtener Recuento de Caracteres",
        "v2GetCharCountDesc": "Obtener Recuento de Caracteres de {{source}} => {{outputVar}}",
        "v2ToLowerCase": "Convertir a Minúsculas",
        "v2ToLowerCaseDesc": "Convertir {{source}} a Minúsculas => {{outputVar}}",
        "v2ToUpperCase": "Convertir a Mayúsculas",
        "v2ToUpperCaseDesc": "Convertir {{source}} a Mayúsculas => {{outputVar}}",
        "v2SetCharAt": "Establecer Carácter en Índice",
        "v2SetCharAtDesc": "Establecer Carácter en Índice {{index}} en {{source}} a {{value}} => {{outputVar}}",
        "v2SplitString": "Dividir Cadena",
        "v2SplitStringDesc": "Dividir {{source}} por {{delimiter}} => {{outputVar}}",
        "v2GetCharacterDesc": "Obtener Descripción del Personaje",
        "v2GetCharacterDescDesc": "Obtener Descripción del Personaje => {{outputVar}}",
        "v2SetCharacterDesc": "Establecer Descripción del Personaje",
        "v2SetCharacterDescDesc": "Establecer Descripción del Personaje a {{value}}",
        "v2GetPersonaDesc": "Obtener Prompt de Persona",
        "v2GetPersonaDescDesc": "Obtener Prompt de Persona => {{outputVar}}",
        "v2SetPersonaDesc": "Establecer Prompt de Persona",
        "v2SetPersonaDescDesc": "Establecer Prompt de Persona a {{value}}",
        "v2GetReplaceGlobalNote": "Obtener Nota Global de Reemplazo",
        "v2GetReplaceGlobalNoteDesc": "Obtener Nota Global de Reemplazo => {{outputVar}}",
        "v2SetReplaceGlobalNote": "Establecer Nota Global de Reemplazo",
        "v2SetReplaceGlobalNoteDesc": "Establecer Nota Global de Reemplazo a {{value}}",
        "v2GetAuthorNote": "Obtener Nota del Autor",
        "v2GetAuthorNoteDesc": "Obtener Nota del Autor => {{outputVar}}",
        "v2SetAuthorNote": "Establecer Nota del Autor",
        "v2SetAuthorNoteDesc": "Establecer Nota del Autor a {{value}}",
        "v2Comment": "Agregar Comentario",
        "v2CommentDesc": "{{value}}",
        "v2DeclareLocalVar": "Declarar Variable Local",
        "v2DeclareLocalVarDesc": "Declarar variable local {{var}} con valor {{value}}",
        "v2MakeArrayVar": "Crear Variable de Matriz",
        "v2MakeArrayVarDesc": "Crear Variable de Matriz {{var}}",
        "v2GetArrayVarLength": "Obtener Longitud de Variable de Matriz",
        "v2GetArrayVarLengthDesc": "Obtener Longitud de Variable de Matriz {{var}} => {{outputVar}}",
        "v2GetArrayVar": "Obtener Variable de Matriz",
        "v2GetArrayVarDesc": "Obtener Valor en Índice {{index}} de Variable de Matriz {{var}} => {{outputVar}}",
        "v2SetArrayVar": "Establecer Variable de Matriz",
        "v2SetArrayVarDesc": "Establecer Valor en Índice {{index}} en Variable de Matriz {{var}} a {{value}}",
        "v2PushArrayVar": "Agregar a Variable de Matriz",
        "v2PushArrayVarDesc": "Agregar {{value}} a Variable de Matriz {{var}}",
        "v2PopArrayVar": "Eliminar y obtener último valor de Variable de Matriz",
        "v2PopArrayVarDesc": "Eliminar último valor de Variable de Matriz {{var}} => {{outputVar}}",
        "v2ShiftArrayVar": "Eliminar y obtener primer valor de Variable de Matriz",
        "v2ShiftArrayVarDesc": "Eliminar primer valor de Variable de Matriz {{var}} => {{outputVar}}",
        "v2UnshiftArrayVar": "Agregar a Variable de Matriz como primer valor",
        "v2UnshiftArrayVarDesc": "Agregar {{value}} como primer valor de Variable de Matriz {{var}}",
        "v2SpliceArrayVar": "Agregar a Variable de Matriz en Índice",
        "v2SpliceArrayVarDesc": "Agregar {{value}} como valor {{start}} de Variable de Matriz {{var}}",
        "v2SliceArrayVar": "Rebanar Variable de Matriz",
        "v2SliceArrayVarDesc": "Rebanar Variable de Matriz {{var}} desde {{start}} hasta {{end}} => {{outputVar}}",
        "v2GetIndexOfValueInArrayVar": "Obtener Índice de Valor en Variable de Matriz",
        "v2GetIndexOfValueInArrayVarDesc": "Obtener Índice de {{value}} en Variable de Matriz {{var}} => {{outputVar}}",
        "v2RemoveIndexFromArrayVar": "Eliminar Índice de Variable de Matriz",
        "v2RemoveIndexFromArrayVarDesc": "Eliminar Valor en Índice {{index}} de Variable de Matriz {{var}}",
        "v2JoinArrayVar": "Unir Matriz",
        "v2JoinArrayVarDesc": "Unir Matriz {{var}} con {{delimiter}} => {{outputVar}}",
        "v2MakeDictVar": "Crear Variable de Diccionario",
        "v2MakeDictVarDesc": "Crear Variable de Diccionario {{var}}",
        "v2GetDictVar": "Obtener Valor de Diccionario",
        "v2GetDictVarDesc": "Obtener Valor para Clave {{key}} de Diccionario {{var}} => {{outputVar}}",
        "v2SetDictVar": "Establecer Valor de Diccionario",
        "v2SetDictVarDesc": "Establecer Valor para Clave {{key}} en Diccionario {{var}} a {{value}}",
        "v2DeleteDictKey": "Eliminar Clave de Diccionario",
        "v2DeleteDictKeyDesc": "Eliminar Clave {{key}} de Diccionario {{var}}",
        "v2HasDictKey": "Tiene Clave de Diccionario",
        "v2HasDictKeyDesc": "Comprobar si Diccionario {{var}} tiene Clave {{key}} => {{outputVar}}",
        "v2ClearDict": "Limpiar Diccionario",
        "v2ClearDictDesc": "Limpiar Diccionario {{var}}",
        "v2GetDictSize": "Obtener Tamaño de Diccionario",
        "v2GetDictSizeDesc": "Obtener Tamaño de Diccionario {{var}} => {{outputVar}}",
        "v2GetDictKeys": "Obtener Claves de Diccionario",
        "v2GetDictKeysDesc": "Obtener Todas las Claves de Diccionario {{var}} => {{outputVar}}",
        "v2GetDictValues": "Obtener Valores de Diccionario",
        "v2GetDictValuesDesc": "Obtener Todos los Valores de Diccionario {{var}} => {{outputVar}}",
        "v2ConcatString": "Concatenar Cadenas",
        "v2ConcatStringDesc": "Concatenar {{source1}} y {{source2}} => {{outputVar}}",
        "v2GetLastUserMessage": "Obtener Último Mensaje de Usuario",
        "v2GetLastUserMessageDesc": "Obtener Último Mensaje de Usuario => {{outputVar}}",
        "v2GetLastCharMessage": "Obtener Último Mensaje de Personaje",
        "v2GetLastCharMessageDesc": "Obtener Último Mensaje de Personaje => {{outputVar}}",
        "v2GetFirstMessage": "Obtener Primer Mensaje",
        "v2GetFirstMessageDesc": "Obtener Primer Mensaje => {{outputVar}}",
        "v2GetAlertInput": "Obtener Entrada de Alerta",
        "v2GetAlertInputDesc": "Obtener Entrada de Alerta => {{outputVar}}",
        "v2GetAlertSelect": "Obtener Selección de Alerta",
        "v2GetAlertSelectDesc": "Obtener Selección de Alerta {{display}} opciones {{value}} => {{outputVar}}",
        "v2UnsupportedTrigger": "Trigger No Soportado",
        "v2UnsupportedTriggerDesc": "Trigger No Soportado",
        "v2GetDisplayState": "Obtener Estado de Visualización",
        "v2GetDisplayStateDesc": "Obtener Estado de Visualización => {{outputVar}}",
        "v2SetDisplayState": "Establecer Estado de Visualización",
        "v2SetDisplayStateDesc": "Establecer Estado de Visualización a {{value}}",
        "v2UpdateGUI": "Actualizar GUI",
        "v2UpdateGUIDesc": "Actualizar GUI",
        "v2UpdateChatAt": "Actualizar Chat en Índice",
        "v2UpdateChatAtDesc": "Redibujar chat en {{index}}",
        "v2Wait": "Esperar",
        "v2WaitDesc": "Esperar {{value}} segundos",
        "v2GetRequestState": "Obtener Contenido de Datos de Solicitud",
        "v2GetRequestStateDesc": "Obtener Contenido de Solicitud en {{index}} => {{outputVar}}",
        "v2SetRequestState": "Establecer Contenido de Datos de Solicitud",
        "v2SetRequestStateDesc": "Establecer Contenido de Solicitud en {{index}} a {{value}}",
        "v2GetRequestStateRole": "Obtener Rol de Datos de Solicitud",
        "v2GetRequestStateRoleDesc": "Obtener Rol de Datos de Solicitud en {{index}} => {{outputVar}}",
        "v2SetRequestStateRole": "Establecer Rol de Datos de Solicitud",
        "v2SetRequestStateRoleDesc": "Establecer Rol de Datos de Solicitud en {{index}} a {{value}}",
        "v2GetRequestStateLength": "Obtener Longitud de Datos de Solicitud",
        "v2GetRequestStateLengthDesc": "Obtener Longitud de Datos de Solicitud => {{outputVar}}",
        "v2IfAdvanced": "Si",
        "v2IfAdvancedDesc": "Si {{source}} {{condition}} {{target}}",
        "v2QuickSearchChat": "Búsqueda Rápida en Chat",
        "v2QuickSearchChatDesc": "Búsqueda rápida {{value}} en chat con condición {{condition}} en profundidad {{depth}} => {{outputVar}}",
        "v2StopPromptSending": "Detener Envío de Prompt",
        "v2StopPromptSendingDesc": "Detener Envío de Prompt",
        "v2Tokenize": "Tokenizar",
        "v2TokenizeDesc": "Tokenizar {{value}} => {{outputVar}}",
        "v2GetAllLorebooks": "Obtener Todos los Libros de Lore",
        "v2GetAllLorebooksDesc": "Obtener todos los prompts de libros de lore como matriz => {{outputVar}}",
        "v2GetLorebookByName": "Obtener Índices de Libro de Lore por Nombre",
        "v2GetLorebookByNameDesc": "Obtener matriz de índices de libros de lore por nombre {{name}} => {{outputVar}}",
        "v2GetLorebookByIndex": "Obtener Libro de Lore",
        "v2GetLorebookByIndexDesc": "Obtener prompt de libro de lore en índice {{index}} => {{outputVar}}",
        "v2CreateLorebook": "Crear Libro de Lore",
        "v2CreateLorebookDesc": "Crear libro de lore con nombre {{name}}, clave {{key}}, contenido {{content}}",
        "v2ModifyLorebookByIndex": "Modificar Libro de Lore",
        "v2ModifyLorebookByIndexDesc": "Modificar libro de lore en índice {{index}} con nombre {{name}}, clave {{key}}, contenido {{content}}",
        "v2DeleteLorebookByIndex": "Eliminar Libro de Lore",
        "v2DeleteLorebookByIndexDesc": "Eliminar libro de lore en índice {{index}}",
        "v2GetLorebookCountNew": "Obtener Recuento de Libro de Lore",
        "v2GetLorebookCountNewDesc": "Obtener recuento total de libros de lore => {{outputVar}}",
        "v2SetLorebookAlwaysActive": "Establecer Libro de Lore Siempre Activo",
        "v2SetLorebookAlwaysActiveDesc": "Establecer libro de lore en índice {{index}} siempre activo a {{value}}",
        "v2Calculate": "Calcular",
        "v2CalculateDesc": "Calcular {{expression}} => {{outputVar}}",
        "v2ReplaceString": "Reemplazar Cadena",
        "v2ReplaceStringDesc": "Reemplazar {{source}} con regex {{regex}} a {{replacement}} => {{outputVar}}"
    },
    "triggerInputLabels": {
        "value": "Valor",
        "var": "Variable",
        "varName": "Nombre de Variable",
        "outputVar": "Variable de Salida",
        "name": "Nombre",
        "index": "Índice",
        "source": "Fuente",
        "target": "Objetivo",
        "condition": "Condición",
        "operator": "Operador",
        "role": "Rol",
        "location": "Ubicación",
        "prompt": "Prompt",
        "model": "Modelo",
        "start": "Inicio",
        "end": "Fin",
        "min": "Mín",
        "max": "Máx",
        "delimiter": "Delimitador",
        "depth": "Profundidad",
        "key": "Clave",
        "alertContent": "Contenido de Alerta",
        "options": "Opciones",
        "cmd": "Comando",
        "regex": "Regex",
        "replacement": "Reemplazo",
        "flags": "Banderas",
        "negPrompt": "Prompt Negativo",
        "resultFormat": "Formato de Resultado",
        "activationKeys": "Claves de Activación",
        "insertOrder": "Orden de Inserción",
        "sysStart": "Inicio del Sistema",
        "sysHistoryEnd": "Fin del Historial del Sistema",
        "sysPromptEnd": "Fin del Prompt del Sistema",
        "addElse": "Agregar Sino",
        "alwaysActive": "Siempre Activo",
        "trigger": "Trigger",
        "triggerOn": "Trigger Activado",
        "valueTypeDesc": "Usar valor de entrada directamente",
        "varTypeDesc": "Usar valor almacenado en variable",
        "conditionEqual": "Igual (=)",
        "conditionNotEqual": "No Igual (≠)",
        "conditionGreater": "Mayor (>)",
        "conditionLess": "Menor (<)",
        "conditionGreaterEqual": "Mayor o Igual (≥)",
        "conditionLessEqual": "Menor o Igual (≤)",
        "conditionSimilar": "Similar (≒)",
        "conditionContains": "Contiene (∋)",
        "conditionIn": "En (∈)",
        "conditionNotContains": "No Contiene (∌)",
        "conditionNotIn": "No En (∉)",
        "conditionTruthy": "Verdadero (≡)",
        "operatorSet": "Establecer (=)",
        "operatorAdd": "Agregar (+=)",
        "operatorSubtract": "Restar (-=)",
        "operatorMultiply": "Multiplicar (*=)",
        "operatorDivide": "Dividir (/=)",
        "operatorModulo": "Módulo (%=)",
        "searchLoose": "Búsqueda Flexible",
        "searchStrict": "Búsqueda Estricta",
        "searchRegex": "Búsqueda Regex",
        "modelMain": "Modelo Principal",
        "modelSub": "Modelo Auxiliar",
        "roleUser": "Usuario",
        "roleChar": "Personaje",
        "roleSystem": "Sistema",
        "roleAssistant": "Asistente",
        "boolTrue": "Verdadero",
        "boolFalse": "Falso",
        "boolNull": "Nulo",
        "helpVarName": "Ingresa el nombre de la variable",
        "helpOutputVar": "Ingresa el nombre de la variable para almacenar el resultado",
        "helpIndex": "Número de índice de matriz o mensaje",
        "helpRegex": "Ingresa el patrón regex",
        "helpFlags": "Banderas Regex",
        "helpDelimiter": "Delimitador para dividir la cadena",
        "helpActivationKeys": "Palabras clave de activación separadas por comas",
        "helpInsertOrder": "Orden de inserción",
        "helpDepth": "Profundidad de mensajes para buscar",
        "helpMinMax": "Rango de valor mínimo y máximo",
        "helpSlot": "Usa {{slot}} para mantener sin cambios",
        "expression": "Expresión"
    },
    "playground": {
        "playground": "Playground",
        "inlayDeleteConfirm": "¿Estás seguro de que deseas eliminar \"{name}\"?",
        "inlayDeleteMultipleConfirm": "¿Estás seguro de que deseas eliminar los {count} recursos seleccionados?",
        "inlayDeleteSelected": "Eliminar seleccionados",
        "inlayDeselectAll": "Deseleccionar todo",
        "inlayEmpty": "Sin recursos inlay guardados",
        "inlayEmptyDesc": "Las imágenes, audios y videos adjuntos o generados en chats aparecerán aquí",
        "inlayExplorer": "Explorador de Recursos Inlay",
        "inlaySelectAll": "Seleccionar todo",
        "inlayTotalAssets": "Total {count} recursos",
    },
    "confirm": "Confirmar",
    "goback": "Volver",
    "botSettings": "Configuración del Bot",
    "model": "Modelo",
    "apiKey": "Clave API",
    "providerURL": "URL de Solicitud",
    "providerJSON": "Cuerpo JSON de la Solicitud",
    "mainPrompt": "Prompt Principal",
    "jailbreakPrompt": "Prompt Jailbreak",
    "globalNote": "Nota Global",
    "autoSuggest": "Auto Sugerir",
    "tokens": "Tokens",
    "maxContextSize": "Tamaño Máximo del Contexto",
    "maxResponseSize": "Tamaño Máximo de la Respuesta",
    "temperature": "Temperatura",
    "frequencyPenalty": "Penalización por Frecuencia",
    "presensePenalty": "Penalización por Presencia",
    "advancedSettings": "Configuraciones Avanzadas",
    "advancedSettingsWarn": "Advertencia: ¡Si no sabes lo que hace la opción, no la cambies!",
    "formatingOrder": "Orden de Formateo",
    "authorNote": "Nota del Autor",
    "firstMessage": "Primer Mensaje",
    "description": "Descripción",
    "note": "Nota",
    "jailbreakToggle": "Alternar Jailbreak",
    "charIcon": "Icono del Personaje",
    "characterDisplay": "Pantalla del Personaje",
    "viewScreen": "Pantalla Adicional del Personaje",
    "none": "Ninguno",
    "emotionImage": "Imágenes de Emoción",
    "noImages": "Sin Imágenes",
    "noBias": "Sin Bias",
    "image": "Imagen",
    "name": "Nombre",
    "folderName": "Nombre de la Carpeta",
    "folderRemoveConfirm": "Esta carpeta contiene libros de lore. ¿Estás seguro de que quieres eliminarla y todo su contenido?",
    "emotion": "Nombre de la Emoción",
    "value": "Valor",
    "reroll": "Regenerar",
    "chatList": "Lista de Chats",
    "removeChat": "¿Eliminar este mensaje?",
    "loreBook": "Libro de Lore",
    "character": "Personaje",
    "Chat": "Chat",
    "globalLoreInfo": "El Libro de Lore del Personaje se aplica a todos los chats del personaje.",
    "group": "Grupo",
    "groupLoreInfo": "El Libro de Lore del Grupo se aplica a todos los chats del grupo.",
    "localLoreInfo": "El Libro de Lore del Chat solo se aplica al chat actual.",
    "removeConfirm": "¿Realmente deseas eliminar: ",
    "removeConfirm2": "¿REALMENTE deseas eliminar: ",
    "exportConfirm": "¿Deseas exportar esto?",
    "insertOrder": "Orden de Inserción",
    "activationKeys": "Claves de Activación",
    "activationKeysInfo": "Separado por comas",
    "prompt": "Prompt",
    "loreBookDepth": "Profundidad de Búsqueda del Libro de Lore",
    "loreBookToken": "Máximo de Tokens del Libro de Lore",
    "chatLoadInitialPages": "Cantidad inicial de carga del chat",
    "chatLoadAdditionalPages": "Cantidad adicional de carga del chat",
    "removeCharacter": "Eliminar Personaje",
    "removeGroup": "Eliminar Grupo",
    "exportCharacter": "Exportar Personaje",
    "userSetting": "Configuración de Usuario",
    "username": "Tu Nombre",
    "userIcon": "Tu Icono",
    "successExport": "Exportado y descargado exitosamente en tu directorio de descargas",
    "successImport": "Importado exitosamente",
    "importedCharacter": "Personaje Importado",
    "alwaysActive": "Siempre Activo",
    "additionalPrompt": "Prompt Adicional",
    "descriptionPrefix": "Prefijo de Descripción",
    "forceReplaceUrl": "Proxy Inverso",
    "emotionWarn": "Se usa modelo auxiliar.",
    "plugin": "Plugin",
    "language": "Idioma",
    "UiLanguage": "Idioma de la Interfaz",
    "createfromScratch": "Crear desde Cero",
    "importCharacter": "Importar Personaje",
    "translator": "Traductor",
    "disabled": "Deshabilitado",
    "noPluginSelected": "Modelo seleccionado como plugin, pero no se seleccionó ningún plugin.",
    "text": "Texto",
    "UISize": "Tamaño del Texto del Chat",
    "newVersion": "Se encontró una actualización, ¿deseas instalarla?",
    "remindLaterQuestion": "¿Cuándo debo recordarte?",
    "remindIgnore": "Ignorar",
    "remindLater1Day": "Recordar en 1 día",
    "remindLater3Days": "Recordar en 3 días",
    "remindLater5Days": "Recordar en 5 días",
    "remindLater1Week": "Recordar en 1 semana",
    "display": "Pantalla y Audio",
    "useCustomBackground": "Fondo Personalizado",
    "translateInput": "Traducir Entrada",
    "autoTranslation": "Traducción Automática",
    "fullscreen": "Pantalla Completa",
    "playMessage": "Reproducir Audio del Mensaje",
    "iconSize": "Tamaño del Icono",
    "createGroup": "Crear Chat de Grupo",
    "groupIcon": "Icono del Grupo",
    "single": "Único",
    "multiple": "Múltiple",
    "useCharLorebook": "Usar Lores en Personajes",
    "selectChar": "Seleccionar Personaje",
    "askLoadFirstMsg": "¿Cargamos el primer mensaje?",
    "theme": "Tema",
    "editOrder": "Editar Orden",
    "autoMode": "Modo Automático",
    "submodel": "Modelo Auxiliar",
    "timeOutinSec": "Tiempo de Espera (en segundos)",
    "emotionPrompt": "Prompt de Emoción",
    "singleView": "Vista Única",
    "SpacedView": "Vista de Múltiples Personajes",
    "emphasizedView": "Vista de Personajes Doble",
    "pluginWarn": "Instalar plugins maliciosos puede causar problemas.",
    "pluginConfirm": "¿Realmente quieres importar este plugin? Solo importa plugins de fuentes confiables.",
    "pluginContainsExternalMedia": "Este plugin contiene medios externos.",
    "pluginContainsExternalJS": "Este complemento contiene Javascript externo.",
    "createGroupImg": "Generar icono de grupo",
    "waifuWidth": "Ancho del Chat Waifu",
    "savebackup": "Guardar Respaldo en Google",
    "loadbackup": "Cargar Respaldo desde Google",
    "files": "Archivos",
    "backupConfirm": "¿Realmente deseas guardar el respaldo?",
    "backupLoadConfirm": "¿Realmente deseas cargar el respaldo? ¡Todos los datos se perderán!",
    "backupLoadConfirm2": "¿Realmente, realmente deseas cargar el respaldo? ¡Todos los datos se perderán!",
    "pasteAuthCode": "Por favor, copia el código de autenticación de la ventana emergente y pégalo aquí:",
    "others": "Otros",
    "presets": "Presets",
    "imageGeneration": "Generación de Imágenes",
    "provider": "Proveedor",
    "key": "Clave",
    "noData": "Sin Datos",
    "currentImageGeneration": "Datos Actuales de Generación de Imágenes",
    "promptPreprocess": "Usar Preprocesamiento de Prompt",
    "SwipeRegenerate": "Usar Swipe para Regeneración",
    "instantRemove": "Eliminar Subsecuente cuando se Elimina Mensaje",
    "instantRemoveConfirm": "¿Deseas eliminar solo un mensaje? Si seleccionas No, entonces el mensaje posterior también se eliminará.",
    "textColor": "Color del Texto",
    "classicRisu": "Risu Clásico",
    "highcontrast": "Alto Contraste",
    "quickPreset": "Puedes cambiar rápidamente el preset con Ctrl + (Índice del Preset)",
    "requestretrys": "Reintentos de Solicitud al Fallar",
    "utilityBot": "Bot de Utilidad",
    "ShowLog": "Mostrar Registros de Solicitud",
    "waifuWidth2": "Tamaño del Personaje Waifu",
    "sayNothing": "Ingresar 'no decir nada' cuando no se haya ingresado ninguna cadena",
    "regexScript": "Script Regex",
    "type": "Tipo",
    "editInput": "Modificar Entrada",
    "editOutput": "Modificar respuesta",
    "editProcess": "Modificar Datos de Solicitud",
    "loadLatest": "Cargar Respaldo más Reciente",
    "loadOthers": "Cargar Otros Respaldos",
    "exampleMessage": "Mensaje de Ejemplo",
    "creatorNotes": "Comentario del Creador",
    "systemPrompt": "Prompt del Sistema",
    "characterNotes": "Notas del Personaje",
    "personality": "Personalidad",
    "scenario": "Escenario",
    "alternateGreetings": "Saludos Alternativos",
    "unrecommended": "No Recomendado",
    "chatNotes": "Notas del Chat",
    "showUnrecommended": "Mostrar Configuraciones No Recomendadas",
    "altGreet": "Mensajes de Inicio Alternativos",
    "scripts": "Scripts",
    "settings": "Configuración",
    "selective": "Selectivo",
    "SecondaryKeys": "Claves Secundarias",
    "useGlobalSettings": "Usar Configuración Global",
    "recursiveScanning": "Escaneo Recursivo",
    "creator": "Creador",
    "CharVersion": "Versión del Personaje",
    "Speech": "Habla",
    "ToggleSuperMemory": "Alternar SupaMemoria",
    "SuperMemory": "SupaMemoria",
    "useExperimental": "Habilitar Funciones Experimentales",
    "showMemoryLimit": "Mostrar Límite de Memoria",
    "showFirstMessagePages": "Mostrar Páginas del Primer Mensaje",
    "roundIcons": "Iconos Redondos",
    "streaming": "Streaming",
    "chatBot": "Chat Bot",
    "otherBots": "Otros Bots",
    "user": "Usuario",
    "additionalAssets": "Activos Adicionales",
    "editDisplay": "Modificar Visualización",
    "community": "Comunidad",
    "textBackgrounds": "Color Personalizado de la Pantalla de Texto",
    "textBorder": "Contornos de Texto",
    "textScreenRound": "Pantalla de Texto Redondeada",
    "textScreenBorder": "Bordes de Pantalla de Texto",
    "ttsReadOnlyQuoted": "Leer Solo Citas",
    "ttsStop": "Detener TTS",
    "askRemoval": "Pedir Confirmación de Eliminación",
    "replaceGlobalNote": "Reemplazo de Nota Global",
    "charLoreBook": "Libro de Lore del Personaje",
    "globalLoreBook": "Libro de Lore Global",
    "globalRegexScript": "Regex Global",
    "accessibility": "Accesibilidad",
    "sendWithEnter": "Enviar con la Tecla Enter(Al desactivar la verificación, Shift + Enter cambia a Transmisión de Mensajes.)",
    "fixedChatTextarea": "Fijación en la parte inferior de la ventana de chat",
    "clickToEdit": "Haz Clic en el Texto para Editar",
    "setNodePassword": "Establece tu contraseña para la seguridad",
    "inputNodePassword": "Ingresa tu contraseña. si no la recuerdas, elimina save/__password.txt en tus archivos de servidor y reinicia el servidor.",
    "simple": "Simple",
    "advanced": "Avanzado",
    "askReRollAutoSuggestions": "Regenerar Auto Sugerencias",
    "creatingSuggestions": "Creando Sugerencias...",
    "orderByOrder": "Hablar por Orden",
    "removeFromGroup": "¿Realmente deseas eliminar a {{char}} del grupo?",
    "talkness": "Hablatividad",
    "active": "Activo",
    "loreRandomActivation": "Usar Condición de Probabilidad",
    "activationProbability": "Probabilidad",
    "shareCloud": "Compartir en RisuRealm",
    "hub": "RisuRealm",
    "tags": "Etiquetas",
    "backgroundHTML": "Incrustación de Fondo",
    "copied": "Copiado",
    "useChatCopy": "Usar Copia de Mensaje de Chat",
    "useChatSticker": "Usar Sticker de Chat",
    "useAdditionalAssetsPreview": "Usar Vista Previa de Activos Adicionales",
    "autoTranslateInput": "Traducción Automática de Entrada",
    "enterMessageForTranslateToEnglish": "Ingresa el Mensaje para Traducir al Inglés",
    "recent": "Reciente",
    "downloads": "Descargas",
    "trending": "Tendencias",
    "imageCompression": "Compresión de Imágenes",
    "notLoggedIn": "No has iniciado sesión en Risu",
    "googleDriveInfo": "Conéctate a Google Drive para sincronizar tus datos.",
    "googleDriveConnection": "Conexión a Google Drive",
    "googleDriveConnected": "Conectado a Google Drive",
    "SaveDataInAccount": "Guardar Datos en la Cuenta",
    "dataSavingInAccount": "Guardando Datos en la Cuenta",
    "logout": "Cerrar Sesión",
    "loadDataFromAccount": "Cargar Datos desde la Cuenta",
    "saveCurrentDataToAccount": "Guardar Datos Actuales en la Cuenta",
    "chatAssumed": "",
    "proxyAPIKey": "Clave/Contraseña del Proxy",
    "proxyRequestModel": "Modelo de Solicitud",
    "officialWiki": "Wiki Oficial",
    "officialWikiDesc": "Wiki Oficial de Risuai. siéntete libre de consultarla.",
    "officialDiscord": "Discord Oficial",
    "officialDiscordDesc": "Discord Oficial para hablar sobre Risuai",
    "persona": "Persona",
    "icon": "Icono",
    "account": "Cuenta",
    "remove": "Eliminar",
    "able": "Habilitar",
    "assetWidth": "Ancho Máximo de Imágenes de Activos",
    "animationSpeed": "Velocidad de Animación",
    "screenshot": "Captura de Pantalla",
    "screenshotSaved": "Captura de Pantalla Guardada",
    "createBotwithAI": "Crear Bot con IA",
    "changeFolderName": "Ingresa el nuevo nombre de la carpeta (deja en blanco para cancelar)",
    "cancel": "Cancelar",
    "renameFolder": "Renombrar Carpeta",
    "changeFolderColor": "Cambiar Color de Carpeta",
    "changeFolderImage": "Cambiar Imagen de Carpeta",
    "fullWordMatching": "Coincidencia Completa de Palabras",
    "botSettingAtStart": "Menú del Bot al Iniciar",
    "triggerStart": "Al enviar chat",
    "triggerInput": "Al enviar respuesta del usuario",
    "triggerOutput": "Al enviar respuesta del personaje",
    "triggerManual": "Solo activación manual",
    "triggerCondVar": "Si Variable",
    "triggerCondExists": "Si el Texto Existe en el Chat",
    "triggerScript": "Script de Activación",
    "triggerMatchRegex": "Coincidir con Regex",
    "triggerMatchLoose": "Coincidir Sin Restricciones",
    "triggerMatchStrict": "Coincidir Estrictamente",
    "searchDepth": "Profundidad de Búsqueda",
    "equal": "Igual a",
    "notEqual": "Diferente de",
    "greater": "Mayor que",
    "less": "Menor que",
    "greaterEqual": "Mayor o Igual que",
    "lessEqual": "Menor o Igual que",
    "triggerEffSysPrompt": "Agregar Prompt del Sistema",
    "triggerEffSetVar": "Modificar Variable",
    "triggerEffImperson": "Enviar Chat",
    "triggerEffCommand": "Ejecutar Comando",
    "triggerEffRunTrigger": "Ejecutar Activación",
    "triggerEffStop": "Detener Envío de Prompt",
    "triggerEffCall": "Llamar a Activación",
    "varableName": "Nombre de la Variable",
    "role": "Rol",
    "location": "Ubicación",
    "promptstart": "Inicio del Prompt",
    "promptend": "Fin del Prompt",
    "historyend": "Fin del Historial",
    "always": "Siempre",
    "noEffect": "Sin Efecto",
    "invaildTriggerEffect": "Este efecto no funciona para este tipo de activación.",
    "operator": "Operador",
    "TriggerSetToVar": "Asignar a Variable",
    "TriggerAddToVar": "Agregar a Variable",
    "TriggerSubToVar": "Restar a Variable",
    "TriggerMulToVar": "Multiplicar a Variable",
    "TriggerDivToVar": "Dividir de Variable",
    "isNull": "no está establecido",
    "ifChatIndex": "Si índice del chat",
    "ifRandom": "Si aleatorio",
    "ifValue": "Si valor",
    "hideRealm": "Ocultar RisuRealm",
    "hideAllImages": "Ocultar todas las imágenes",
    "popularityLevel": "{} Popularidad",
    "colorScheme": "Esquema de Colores",
    "rangeStart": "Inicio del Rango",
    "rangeEnd": "Fin del Rango",
    "untilChatEnd": "Hasta el Fin del Chat",
    "usePromptTemplate": "Usar Plantilla de Prompt",
    "specialType": "Tipo Especial",
    "noSpecialType": "Sin Tipo Especial",
    "forceProxyAsOpenAI": "Forzar Formato de Proxy como OpenAI",
    "promptTemplate": "Plantilla de Prompt",
    "customInnerFormat": "Formato Interno Personalizado",
    "innerFormat": "Formato Interno",
    "HypaMemory": "HypaMemoria",
    "ToggleHypaMemory": "Alternar HypaMemoria",
    "resetPromptTemplateConfirm": "¿Realmente deseas restablecer la plantilla de prompt?",
    "emotionMethod": "Método de Emoción",
    "continueResponse": "Continuar Respuesta",
    "showMenuChatList": "Mostrar Menú de Lista de Chats",
    "translatorLanguage": "Idioma del Traductor",
    "translatorType": "Tipo de Traductor",
    "htmlTranslation": "Traducción de HTML",
    "deeplKey": "Clave API de DeepL",
    "deeplFreeKey": "Clave API Gratis de DeepL",
    "deeplXUrl": "URL de DeepLX",
    "deeplXToken": "Token de DeepLX",
    "exportPersona": "Exportar Persona",
    "importPersona": "Importar Persona",
    "export": "Exportar",
    "import": "Importar",
    "supporterThanks": "Agradecimiento a los Soportes",
    "supporterThanksDesc": "¡Gracias por tu apoyo!",
    "donatorPatreonDesc": "Por defecto, no se mostrará en la lista por privacidad. Si deseas mostrar tu apodo, ve a la página de patreon de Risuai y presiona el botón de enlace.",
    "useNamePrefix": "Usar Prefijo de Nombre",
    "textAdventureNAI": "Ejecutar como Aventura de Texto",
    "appendNameNAI": "Agregar Nombre en NAI",
    "customStopWords": "Palabras de Parada Personalizadas",
    "defaultPrompt": "Prompt Predeterminado",
    "additionalText": "Descripción Adicional",
    "seed": "Semilla",
    "charjs": "CharacterJS",
    "depthPrompt": "Prompt de Profundidad",
    "largePortrait": "Retrato",
    "lorePlus": "LoreBook+",
    "reverseProxyOobaMode": "Modo Ooba",
    "joinMultiUserRoom": "Unirse a Sala MultiUsuario",
    "exactTokens": "Tokens Exactos",
    "fixedTokens": "Tokens Aproximados",
    "inlayViewScreen": "Pantalla de Incrustación",
    "imgGenPrompt": "Prompt de Generación de Imágenes",
    "imgGenNegatives": "Prompt Negativo de Generación de Imágenes",
    "imgGenInstructions": "Instrucciones para Generación de Imágenes",
    "usePlainFetchWarn": "Desactiva esta opción cuando uses NovelAI, ya que puede causar errores de CORS al usar NovelAI.",
    "translationPrompt": "Prompt de Traducción",
    "translationResponseSize": "Tamaño de Respuesta de Traducción",
    "webdeeplwarn": "Esta opción no se recomienda para su uso con la versión web, ya que puede causar errores de CORS.",
    "saveBackupLocal": "Guardar Respaldo Localmente",
    "loadBackupLocal": "Cargar Respaldo Localmente",
    "topP": "Top P",
    "genTimes": "Opciones de Generación",
    "cot": "Cadena de Pensamientos",
    "forcePlainFetch": "Forzar Fetch Simple",
    "autoFillRequestURL": "Autocompletar URL de Solicitud",
    "newOAIHandle": "Nuevo Manejo de OpenAI",
    "inlayImage": "Característica de Incrustación de Imágenes",
    "nativeAutomark": "Automarcación Nativa Experimental",
    "assistantPrefill": "Relleno Automático del Asistente",
    "postEndInnerFormat": "Formato Interno Post Fin",
    "sendChatAsSystem": "Enviar Chat como Sistema",
    "sendName": "Enviar Nombre en Chat No Grupal",
    "utilOverride": "Anulación de Utilidad",
    "template": "Plantilla",
    "chatAsOriginalOnSystem": "Enviar como rol original",
    "exportAsDataset": "Exportar Guardado como Conjunto de Datos",
    "editTranslationDisplay": "Editar Visualización de Traducción",
    "selectModel": "Seleccionar Modelo",
    "autoRemoveThoughtTag": "Eliminar Etiqueta de Pensamiento",
    "customChainOfThought": "Cadena de Pensamientos Personalizada",
    "maxThoughtTagDepth": "Profundidad Máxima de Etiqueta de Pensamiento",
    "openRouterFallback": "Fallback de Openrouter",
    "openRouterMiddleOut": "Middle Out de Openrouter",
    "openRouterProviderOrder": "Orden de Preferencia del Proveedor",
    "openRouterProviderOnly": "Proveedores Permitidos",
    "openRouterProviderIgnore": "Proveedores Ignorados",
    "openRouterSearchModel": "Buscar modelos...",
    "openRouterSortByName": "Nombre",
    "openRouterSortByPrice": "Precio",
    "openRouterSortByProvider": "Proveedor",
    "openRouterSortAsc": "Ascendente",
    "openRouterSortDesc": "Descendente",
    "geminiApiKey": "Clave API de Gemini",
    "removePunctuationHypa": "Eliminación de Puntuación de Memoria",
    "memoryLimitThickness": "Grosor del Límite de Memoria",
    "inputCardPassword": "Ingresa la Contraseña de la Tarjeta",
    "ccv2Desc": "Character Card V2 es un formato ampliamente utilizado en programas de chatbot.",
    "ccv3Desc": "Character Card V3 es un formato de próxima generación que se usa en programas de chatbot.",
    "realmDesc": "RisuRealm es una plataforma de compartición de contenido para Risuai. Puedes compartir tu personaje con otros usuarios.",
    "rccDesc": "Risu Refined Character Card es un formato con características adicionales como contraseña, verificación de integridad, etc.",
    "password": "Contraseña",
    "license": "Licencia",
    "licenseDesc": "Puedes elegir la licencia para los descargadores para limitar los usos del prompt de tu tarjeta.",
    "passwordDesc": "Puedes establecer una contraseña para proteger tu tarjeta de accesos no autorizados.",
    "largePersonaPortrait": "Retrato de Persona",
    "module": "Módulo",
    "modules": "Módulos",
    "noModules": "No se han instalado módulos.",
    "createModule": "Crear Módulo",
    "basicInfo": "Información Básica",
    "moduleContent": "Contenido del Módulo",
    "confirmRemoveModuleFeature": "¿Realmente deseas eliminar esta característica? Esta acción no se puede deshacer.",
    "editModule": "Editar Módulo",
    "importModule": "Importar Módulo",
    "download": "Descargar",
    "edit": "Editar",
    "enableGlobal": "Habilitar Globalmente",
    "chatModulesInfo": "Puedes habilitar o deshabilitar módulos para este chat.",
    "sideMenuRerollButton": "Botón de Regeneración en el Menú Lateral",
    "persistentStorage": "Almacenamiento Persistente",
    "persistentStorageSuccess": "El almacenamiento se ha persistido exitosamente",
    "persistentStorageFail": "El almacenamiento no se ha persistido. ¿Rechazaste la solicitud?, ¿o el navegador no es compatible?",
    "persistentStorageRecommended": "Se recomienda el Almacenamiento Persistente",
    "persistentStorageDesc": "Tu navegador admite almacenamiento persistente. Esto se recomienda para un mejor rendimiento y experiencia del usuario.",
    "enable": "Habilitar",
    "postFile": "Publicar Archivo",
    "requestInfoInsideChat": "Mostrar Información de la Solicitud Dentro del Chat",
    "inputTokens": "Tokens de Entrada",
    "outputTokens": "Tokens de Salida",
    "tokenWarning": "El cálculo de tokens puede ser inexacto. se recomienda usarlo como referencia.",
    "log": "Registro",
    "popularityLevelDesc": "La popularidad aumenta con las descargas, etc. Para estimar, 3.7 de popularidad equivale a aproximadamente 1 descarga.",
    "additionalParams": "Parámetros Adicionales",
    "heightMode": "Modo de Altura",
    "useAdvancedEditor": "Usar Editor Avanzado",
    "noWaitForTranslate": "Sin Espera para Traducir",
    "updateRealm": "Actualizar a RisuRealm",
    "updateRealmDesc": "Estás intentando actualizar tu personaje a RisuRealm. Esto actualizará tu personaje en RisuRealm, y no podrás revertirlo.",
    "antiClaudeOverload": "Anti-Sobrecarga de Claude",
    "activeTabChange": "La pestaña actual se desactivó porque otra pestaña está activa. para activar esta pestaña, haz clic en Aceptar",
    "maxSupaChunkSize": "Tamaño Máximo del Chunk de SupaMemoria",
    "addCharacter": "Agregar Personaje",
    "importFromRealm": "Elegir desde RisuRealm",
    "importFromRealmDesc": "Elige entre más de 1000 personajes en RisuRealm",
    "random": "Aleatorio",
    "metaData": "Meta Data",
    "autoContinueMinTokens": "Tokens Objetivo (Continuar Automáticamente)",
    "autoContinueChat": "Anti-Respuesta Incompleta (Continuar Automáticamente)",
    "removeIncompleteResponse": "Eliminar Frases Incompletas",
    "tokenizer": "Tokenizador",
    "chatFormating": "Formateo de Chat",
    "useInstructPrompt": "Usar Prompt de Instrucción",
    "hanuraiMemory": "HanuraiMemoria",
    "textAreaSize": "Tamaño del Área de Entrada",
    "textAreaTextSize": "Tamaño del Texto del Área de Entrada",
    "sideBarSize": "Tamaño de la Barra Lateral",
    "embedding": "Embedding",
    "syntax": "Sintaxis",
    "run": "Ejecutar",
    "noMessage": "Escribe algo para comenzar el chat.",
    "combineTranslation": "Combinar Traducción",
    "dynamicAssets": "Activos Dinámicos",
    "dynamicAssetsEditDisplay": "Usar Activos Dinámicos en Visualización",
    "longTermMemory": "Memoria a Largo Plazo",
    "grid": "Cuadrícula",
    "list": "Lista",
    "trash": "Papelera",
    "trashDesc": "Los personajes eliminados se mueven a la papelera. Puedes restaurarlos o eliminarlos permanentemente. Los personajes eliminados se purgan automáticamente después de 3 días.",
    "shareExport": "Compartir/Exportar",
    "risupresetDesc": "El formato Risupreset es un formato específicamente diseñado para presets de Risuai.",
    "risuMDesc": "El formato RisuM es un formato diseñado específicamente para módulos de Risuai.",
    "jsonDesc": "El formato JSON es un formato fácil de leer y escribir tanto para humanos como para máquinas.",
    "nickname": "Apodo",
    "useRegexLorebook": "Usar Regex",
    "customPromptTemplateToggle": "Alternar Plantillas Personalizadas",
    "defaultVariables": "Variables Predeterminadas",
    "hypaAllocatedTokens": "Tokens Asignados",
    "hypaChunkSize": "Tamaño del Chunk",
    "hypaV2Desc": "HypaMemory V2 es un sistema de memoria a largo plazo que utiliza tanto datos resumidos como búsqueda de vectores.",
    "supaDesc": "SupaMemory es un sistema de memoria a largo plazo que utiliza datos resumidos para la IA.",
    "hanuraiDesc": "HanuraiMemory es un sistema de memoria que utiliza búsqueda de vectores.",
    "lowLevelAccess": "Acceso de Bajo Nivel",
    "resultStoredVar": "Variable para Almacenar el Resultado",
    "triggerEffRunLLM": "Ejecutar Modelo Principal",
    "triggerEffectSendAI": "Reenviar IA",
    "triggerEffCheckSim": "Verificar Similitud",
    "triggerEffShowAlert": "Mostrar Alerta",
    "normal": "Normal",
    "error": "Error",
    "input": "Entrada",
    "select": "Seleccionar",
    "options": "Opciones",
    "alertContent": "Contenido de Alerta",
    "lowLevelAccessConfirm": "Este contenido usa Acceso de Bajo Nivel. lo que significa que este contenido puede acceder al modelo de IA y a tu almacenamiento directamente. ¿Realmente deseas importar este contenido?",
    "triggerLowLevelOnly": "Este activador solo funciona con Acceso de Bajo Nivel. para habilitar este activador, habilita Acceso de Bajo Nivel en configuraciones avanzadas en el personaje o módulo.",
    "truthy": "Truthy",
    "extractRegex": "Extraer Texto con Regex",
    "runImgGen": "Ejecutar Generación de Imágenes",
    "cutChat": "Cortar Chat",
    "modifyChat": "Modificar Chat",
    "regex": "Regex",
    "flags": "Flags",
    "resultFormat": "Formato del Resultado",
    "negPrompt": "Prompt Negativo",
    "start": "Inicio",
    "end": "Fin",
    "index": "Índice",
    "search": "Buscar",
    "goCharacterOnImport": "Ir al Personaje al Importar desde Realm",
    "format": "Formato",
    "v2Warning": "Advertencia: La tarjeta V2 ya no es compatible. puede que no contenga todos los datos.",
    "applyModule": "Aplicar Módulo",
    "successApplyModule": "El módulo se aplicó exitosamente",
    "font": "Fuente",
    "lineHeight": "Altura de Línea",
    "loadAutoServerBackup": "Cargar Respaldo Automático del Servidor",
    "notCharxWarn": "Este personaje usa múltiples activos. se recomienda exportar este personaje como un formato CharX para mejor compatibilidad.",
    "noPlugins": "No hay Plugins Instalados",
    "legacyTranslation": "Traducción Legacy",
    "clipboardSuccess": "Copiado al Portapapeles",
    "translateContent": "Traducir Contenido",
    "doNotTranslate": "No Traducir",
    "includePersonaName": "Incluir Nombre de la Persona",
    "hidePersonaName": "Ocultar Nombre de la Persona",
    "triggerSwitchWarn": "Si cambias el tipo de activador, los activadores actuales se perderán. ¿deseas continuar?",
    "codeMode": "Modo Código",
    "blockMode": "Modo Bloque",
    "helpBlock": "Ayuda",
    "hideChatIcon": "Ocultar Icono de UI",
    "loadInternalBackup": "Cargar Respaldo Interno",
    "createCopy": "Crear una Copia",
    "bindPersona": "Vincular Persona",
    "chatOptions": "Opciones de Chat",
    "doYouWantToBindCurrentPersona": "¿Deseas vincular la persona actual a este chat?",
    "doYouWantToUnbindCurrentPersona": "¿Deseas desvincular la persona de este chat?",
    "personaBindedSuccess": "Persona vinculada exitosamente",
    "personaUnbindedSuccess": "Persona desvinculada exitosamente",
    "parameters": "Parámetros",
    "sizeAndSpeed": "Tamaño y Velocidad",
    "useLegacyGUI": "Usar Interfaz Legacy",
    "claudeCachingExperimental": "Claude Caching",
    "openClose": "Abrir/Cerrar",
    "hideApiKeys": "Ocultar Claves API",
    "unformatQuotes": "Desactivar Formato de Citas",
    "enableDevTools": "Habilitar Herramientas de Desarrollo",
    "selectFile": "Seleccionar Archivo",
    "namespace": "Namespace",
    "moduleIntergration": "Integración de Módulos",
    "previewInfo": "Esta vista previa muestra el prompt antes del procesamiento específico del modelo.",
    "miscTools": "Herramientas Varias",
    "promptConvertion": "Conversión de Prompt",
    "convertionStep1": "Selecciona todos los archivos relacionados con el prompt (Contexto, Instrucción y Sampler JSON compatibles)",
    "customCSS": "CSS Personalizado",
    "betaMobileGUI": "GUI Móvil Beta",
    "menu": "Menú",
    "connectionOpen": "Conexión Abierta",
    "connectionOpenInfo": "La sala multiusuario está abierta. Puedes compartir el código de la sala con otros usuarios. Otros pueden unirse a la sala usando el código dentro de playground > Unirse a Sala Multiusuario.",
    "createMultiuserRoom": "Crear Sala Multiusuario",
    "connectionHost": "Eres el anfitrión de la sala.",
    "connectionGuest": "Eres el invitado de la sala.",
    "otherUserRequesting": "Otro usuario ya está solicitando. Inténtalo de nuevo más tarde.",
    "jsonSchema": "Esquema JSON",
    "enableJsonSchema": "Habilitar Esquema",
    "strictJsonSchema": "Esquema Estricto",
    "extractJson": "Extraer JSON",
    "reloadSession": "Se encontró una versión más nueva de los datos guardados. Recargando la sesión...",
    "fixMarkdownNewline": "Arreglar Nueva Línea en Markdown",
    "customQuotes": "Citas Personalizadas",
    "leadingSingleQuote": "Cita Simple Inicial",
    "leadingDoubleQuote": "Cita Doble Inicial",
    "trailingSingleQuote": "Cita Simple Final",
    "trailingDoubleQuote": "Cita Doble Final",
    "translatorNote": "Nota del Traductor",
    "formatGroupInSingle": "Formatear Grupo en Único",
    "groupInnerFormat": "Formato Interno de No Hablante",
    "groupOtherBotRole": "Rol de No Hablante en Grupo",
    "defineCustomGUI": "Definir GUI Personalizada",
    "chatHTML": "HTML del Chat",
    "logShare": "Mostrar Botón de Compartir Registro",
    "preview": "Vista Previa",
    "recommended": "Recomendado",
    "newChat": "Nuevo Chat",
    "predictedOutput": "Salida Predicha",
    "systemContentReplacement": "Reemplazo de Contenido del Sistema",
    "systemRoleReplacement": "Reemplazo de Rol del Sistema",
    "seperateParameters": "Parámetros Separados",
    "seperateParametersEnabled": "Habilitar Parámetros Separados",
    "summarizationPrompt": "Prompt de Resumen",
    "reSummarizationPrompt": "Prompt de Re-Resumen",
    "translatorPrompt": "Prompt de Traducción",
    "translateBeforeHTMLFormatting": "Traducir Antes del Formateo HTML",
    "retranslate": "Retraducir",
    "editTranslation": "Editar traducción",
    "editTranslationSave": "Guardar traducción",
    "exportTranslationCache": "Exportar caché de traducción",
    "exportTranslationCacheSuccess": "Caché de traducción exportada correctamente.",
    "importTranslationCache": "Importar caché de traducción",
    "importTranslationCacheConfirm": "Esto fusionará las entradas en la caché de traducción. Las claves existentes se sobrescribirán. ¿Continuar?",
    "importTranslationCacheSuccess": "Se importaron {0} entradas del caché de traducción.",
    importTranslationCacheFailed: "Se importaron {0} entradas, pero {1} entradas no se pudieron guardar. El almacenamiento puede estar lleno.",
    "exportTranslationCacheEmpty": "El caché de traducción está vacío.",
    clearTranslationCache: "Borrar caché de traducción",
    clearTranslationCacheSuccess: "Caché de traducción borrada correctamente.",
    clearTranslationCacheConfirm: "Esto eliminará todas las entradas de la caché de traducción. Esta acción no se puede deshacer. ¿Continuar?",
    "loading": "Cargando",
    "autoTranslateCachedOnly": "Traducir Automáticamente Solo Mensajes en Caché",
    "notification": "Notificación",
    "permissionDenied": "Permiso Denegado por tu Navegador o SO",
    "customFlags": "Flags Personalizados",
    "enableCustomFlags": "Habilitar Flags Personalizados",
    "googleCloudTokenization": "Tokenización de Google Cloud",
    "presetChain": "Cadena de Presets",
    "legacyMediaFindings": "Hallazgos de Medios Legacy",
    "staticsDisclaimer": "Las estadísticas se basan en los datos de después de julio de 2024. Los datos pueden no ser precisos.",
    "subtitles": "Subtítulos",
    "subtitlesWarning1": "Debes usar un modelo con entrada de audio/video para usar esta función.",
    "subtitlesWarning2": "Debes usar un modelo con función de transmisión para usar esta función.",
    "reset": "Restablecer",
    "assetMaxDifference": "Diferencia Máxima de Activos",
    "sourceLanguage": "Idioma de Origen",
    "destinationLanguage": "Idioma de Destino",
    "noWebGPU": "Tu navegador o SO no soporta WebGPU. Esto ralentizará el rendimiento significativamente.",
    "menuSideBar": "Barra Lateral del Menú",
    "home": "Inicio",
    "showSavingIcon": "Mostrar Icono de Guardado",
    "pluginVersionWarn": "Esta es la versión {{plugin_version}} del plugin, que no es compatible con esta versión de Risuai. Por favor, actualiza el plugin a la versión {{required_version}}.",
    "imageTranslation": "Traducción de Imagen",
    "banCharacterset": "Regeneración Automática en Conjunto de Caracteres",
    "realmDirectOpen": "Abrir personaje directamente en RisuRealm",
    "showPromptComparison": "Mostrar Comparación de Prompt",
    "inlayErrorResponse": "Respuesta de Error de Incrustación",
    "triggerOn": "Trigger Activado",
    "noConfig": "Sin Configuración",
    "varName": "Nombre de Variable",
    "var": "Variable",
    "condition": "Condición",
    "trigger": "Trigger",
    "outputVar": "Variable de Salida",
    "source": "Fuente",
    "cmd": "Comando",
    "sysStart": "Inicio del Sistema",
    "sysHistoryEnd": "Fin del Historial del Sistema",
    "sysPromptEnd": "Fin del Prompt del Sistema",
    "target": "Objetivo",
    "addElse": "Agregar Sino",
    "min": "Mín",
    "max": "Máx",
    "delimiter": "Delimitador",
    "deleteCount": "Contador de Eliminación",
    "triggerEffRunAxLLM": "Ejecutar Modelo Auxiliar",
    "hypaV3Settings": {
        "descriptionLabel": "HypaMemory V3 es un sistema de memoria a largo plazo que utiliza tanto resúmenes como búsqueda vectorial.",
        "supaMemoryPromptPlaceHolder": "Dejar en blanco para usar el valor predeterminado",
        "maxMemoryTokensRatioLabel": "Ratio Máximo de Tokens de Memoria (Estimado)",
        "maxMemoryTokensRatioError": "No se puede calcular el ratio máximo de tokens de memoria",
        "memoryTokensRatioLabel": "Ratio de Tokens de Memoria",
        "extraSummarizationRatioLabel": "Ratio de Resumen Adicional",
        "maxChatsPerSummaryLabel": "Mensajes Máximos por Resumen",
        "recentMemoryRatioLabel": "Ratio de Memoria Reciente",
        "similarMemoryRatioLabel": "Ratio de Memoria Similar",
        "randomMemoryRatioLabel": "Ratio de Memoria Aleatoria",
        "enableSimilarityCorrectionLabel": "Activar Corrección de Similitud",
        "preserveOrphanedMemoryLabel": "Preservar Memoria Huérfana",
        "applyRegexScriptWhenRerollingLabel": "Aplicar Script Regex al Regenerar",
        "doNotSummarizeUserMessageLabel": "No Resumir Mensajes del Usuario"
    },
    "hypaV3Modal": {
        "titleLabel": "HypaV3",
        "resetConfirmMessage": "Esta acción no se puede deshacer. ¿Desea restablecer los datos de HypaV3?",
        "resetConfirmSecondMessage": "Esta acción es irreversible. ¿Está realmente seguro de querer restablecer los datos de HypaV3?",
        "convertLabel": "Aún no hay resúmenes, pero puede convertir datos de HypaV2 a V3.",
        "convertButton": "Convertir a V3",
        "convertSuccessMessage": "Datos de HypaV2 convertidos exitosamente a V3",
        "convertErrorMessage": "Error al convertir datos de HypaV2 a V3: {0}",
        "noSummariesLabel": "Aún no hay resúmenes",
        "searchPlaceholder": "Ingrese #N, ID o búsqueda",
        "summaryNumberLabel": "Resumen #{0}",
        "deleteThisConfirmMessage": "¿Eliminar este resumen?",
        "deleteAfterConfirmMessage": "¿Eliminar todos los resúmenes después de este?",
        "deleteAfterConfirmSecondMessage": "Esta acción no se puede deshacer. ¿Está realmente seguro?",
        "translationLabel": "Traducción",
        "rerolledSummaryLabel": "Resumen Regenerado",
        "rerolledTranslationLabel": "Traducción del Resumen Regenerado",
        "connectedMessageCountLabel": "Mensajes Conectados ({0})",
        "connectedFirstMessageLabel": "Primer Mensaje",
        "connectedMessageRoleLabel": "Mensaje de {0}",
        "connectedMessageNotFoundLabel": "Mensaje no encontrado",
        "connectedMessageLoadingError": "Error al cargar mensaje conectado: {0}",
        "connectedMessageTranslationLabel": "Traducción",
        "nextSummarizationFirstMessageLabel": "Primer Mensaje",
        "nextSummarizationNoMessageIdLabel": "Sin ID de Mensaje",
        "nextSummarizationLabel": "HypaV3 resumirá [{0}]",
        "nextSummarizationNoMessagesFoundLabel": "ADVERTENCIA: No se encontraron mensajes",
        "nextSummarizationLoadingError": "Error al cargar el siguiente objetivo de resumen: {0}",
        "summarizationConditionLabel": "Consejo: HypaV3 comienza a resumir cuando los tokens de entrada superan el tamaño máximo de contexto.",
        "emptySelectedFirstMessageLabel": "ADVERTENCIA: El primer mensaje seleccionado está vacío",
        "unclassified": "Sin Clasificar",
        "reSummarize": "Re-resumir",
        "reSummarizing": "Re-resumiendo...",
        "reSummarizeResult": "Resultado de Re-resumen",
        "retry": "Reintentar",
        "translate": "Traducir",
        "tag": "Etiqueta",
        "tagManager": "Gestor de Etiquetas",
        "tagManagerTitle": "Gestor de Etiquetas - Resumen #{0}",
        "newTagName": "Nuevo nombre de etiqueta",
        "noTagsYet": "Aún no hay etiquetas.",
        "addNewTagHint": "Añade una nueva etiqueta arriba.",
        "categoryManager": "Categorías",
        "allCategories": "Todas",
        "categoryName": "Nombre de categoría",
        "noCategoriesYet": "Aún no hay categorías.",
        "addNewCategoryHint": "Haz clic en el botón + arriba para añadir una."
    },
    "bulkEnabling": "Habilitación Masiva de Libro de Lore",
    "showTranslationLoading": "Mostrar Cargando Traducción",
    "showDeprecatedTriggerV1": "Mostrar Trigger V1 Obsoleto",
    "showDeprecatedTriggerV2": "Mostrar Trigger V2 Obsoleto",
    "triggerV1Warning": "El Trigger V1 está obsoleto. podría ser eliminado en el futuro.",
    "copy": "Copiar",
    "paste": "Pegar",
    "depth": "Profundidad",
    "returnCSSError": "Error de CSS devuelto",
    "alwaysActiveInChat": "Siempre Activo (Chat Actual)",
    "childLoreDesc": "Esta es una copia del lore del Personaje que permanece 'Siempre Activo' hasta que se elimine o desactive manualmente en el original.",
    "thinkingTokens": "Tokens de Pensamiento",
    "antiServerOverload": "Anti-Sobrecarga del Servidor",
    "localActivationInGlobalLorebook": "Activación Local en Libro de Lore Global",
    "cachePoint": "Punto de Caché",
    "all": "Todos",
    "showFolderNameInIcon": "Mostrar Nombre de Carpeta en Icono",
    "claudeCachingRetrival": "Recuperación de Caché de Claude",
    "claudeCachingRetrivalDesc": "Extiende el tiempo de caché para Claude Caching, solicitando cada 4 minutos. esto puede reducir la tasa de fallos de caché, pero puede aumentar el costo si no se usa correctamente.",
    "automaticCachePoint": "Punto de Caché Automático",
    "experimentalChatCompression": "Manejo Experimental de Datos de Chat",
    "loadingChatData": "Cargando Datos de Chat",
    "outputImageModal": "Modal de Imagen de Salida",
    "playMessageOnTranslateEnd": "Reproducir Audio al Completar Traducción",
    "auxModelUnderModelSettings": "Mostrar Modelos Auxiliares Separados en Configuración de Modelo",
    "seperateModelsForAxModels": "Modelos Separados para Modelos Auxiliares",
    "axModelsDef": "Definición de Modelos Auxiliares",
    "doNotChangeSeperateModels": "No Cambiar Modelos Separados al Cambiar Preset",
    "tools": "Herramientas",
    "action": "Acción",
    "hotkey": "Tecla de Acceso Rápido",
    "hotkeyDesc": {
        "reroll": "Regenerar",
        "unreroll": "Deshacer Regeneración",
        "translate": "Traducir",
        "remove": "Eliminar",
        "edit": "Editar",
        "copy": "Copiar",
        "send": "Enviar",
        "settings": "Configuración",
        "home": "Inicio",
        "presets": "Selección Rápida de Presets",
        "persona": "Selección Rápida de Persona",
        "modelSelect": "Selección Rápida de Modelo",
        "toggleCSS": "Alternar CSS",
        "prevChar": "Personaje Anterior",
        "nextChar": "Siguiente Personaje",
        "quickMenu": "Menú Rápido",
        "quickSettings": "Configuración Rápida",
        "toggleVoice": "Alternar Voz",
        "toggleLog": "Alternar Registro",
        "previewRequest": "Vista Previa de Solicitud",
        "import": "Importar",
        "export": "Exportar",
        "webcam": "Alternar Webcam",
        "focusInput": "Enfocar Entrada",
        "scrollToActiveChar": "Desplazarse al personaje activo"
    },
    "screenTooSmall": "La pantalla es demasiado pequeña para mostrar la interfaz.",
    "advancedModelSettings": "Configuraciones Avanzadas del Modelo",
    "fallbackModel": "Modelo de Fallback",
    "fallbackWhenBlankResponse": "Fallback Cuando Respuesta en Blanco",
    "doNotChangeFallbackModels": "No Cambiar Modelos de Fallback al Cambiar Preset",
    "customModels": "Modelos Personalizados",
    "igpPrompt": "Prompt IGP",
    "useTokenizerCaching": "Caché de Tokenizador",
    "hypaMemoryV2Modal": "Modal Hypa V2",
    "hypaMemoryV3Modal": "Modal Hypa V3",
    "showMenuHypaMemoryModal": "Mostrar Menú Modal Hypa",
    "promptInfoInsideChat": "Agregar Info de Prompt al Chat",
    "promptTextInfoInsideChat": "Agregar Texto de Prompt al Chat",
    "promptInfoEmptyMessage": "No hay información de prompt disponible para este mensaje.",
    "promptInfoEmptyToggle": "No hay interruptores personalizados activos actualmente.",
    "promptInfoEmptyText": "No se ha guardado texto de prompt.",
    "escapeOutput": "Escapar Salida",
    "openAIFlexProcessing": "Procesamiento Flex de OpenAI",
    "claudeBatching": "Batching de Claude",
    "claude1HourCaching": "Caché de Claude de 1 Hora",
    "folderNameInput": "Por favor ingrese el nuevo nombre de la carpeta",
    "folderRemoveLengthError": "Para eliminar una carpeta, no debe contener ninguna entrada.",
    "personaNote": "Nota de Persona",
    "mcpAccessPrompt": "{{tool}} está intentando \"{{action}}\". ¿deseas permitir esto?",
    "rememberToolUsage": "Recordar uso de herramienta",
    "simplifiedToolUse": "Uso simplificado de herramientas",
    "toolCalled": "Herramienta '{{tool}}' Llamada",
    "static": "Estático",
    "dynamic": "Dinámico",
    "assetStyle": "Estilo de Activo",
    "insertAssetPrompt": "Insertar Prompt de Activo",
    "requestLocation": "Ubicación de Solicitud",
    "newImageHandlingBeta": "Nuevo Manejo de Imágenes (Beta)",
    "settingsExported": "Configuración para informe de errores exportada y copiada al portapapeles.",
    "bookmarks": "Marcadores",
    "noBookmarks": "Sin Marcadores",
    "bookmarkAskNameOrDefault": "Ingresa el nombre del marcador. Si no se ingresa, se asignará automáticamente.",
    "bookmarkAskNameOrCancel": "Ingresa el nombre del marcador. Si no se ingresa, se cancelará el cambio de nombre.",
    "collapseAll": "Contraer Todo",
    "expandAll": "Expandir Todo",
    "hideErrorDetails": "Ocultar Detalles del Error",
    "showErrorDetails": "Mostrar Detalles del Error",
    "dynamicOutput": "Salida Dinámica",
    "autoAdjustSchema": "Ajustar Esquema Automáticamente",
    "dynamicMessages": "Mensajes Dinámicos",
    "dynamicMemory": "Memoria Dinámica",
    "dynamicResponseTiming": "Tiempo de Respuesta Dinámico",
    "showTypingEffect": "Mostrar Efecto de Escritura",
    "dynamicRequest": "Solicitud Dinámica",
    "dynamicOutputPrompt": "Prompt de Salida Dinámica",
    "settingsCloseButtonSize": "Tamaño del botón de cerrar configuración",
    "translating": "Traduciendo...",
    "stackTraceTranslationFailed": "La traducción del seguimiento de pila falló. Se muestra abajo el seguimiento de pila ofuscado original.",
    "translate": "Traducir dirección de código",
    "apply": "Aplicar",
    "add": "Agregar",
    "nightlyWarning": "## Builds Nightly\n\nTe estás conectando a una build nightly del software. Esta versión está destinada a pruebas y muy probablemente contiene errores. **En esta versión, incluso si encuentras problemas, no admitimos resolverlos directamente.**",
    "loginSionyw": "Iniciar sesión con cuenta de Sionyw",
    "pluginRiskDetectedAlert": "Risuai detectó código que puede ser dañino y que podría ROBAR TU CLAVE API O DATOS PERSONALES. te recomendamos NO INSTALAR ESTE PLUGIN.",
    "doNotInstall": "No Instalar",
    "continueAnyway": "Continuar de Todos Modos",
    "pluginNoRiskButAlert": "Risuai no detectó código dañino, pero ten en cuenta que instalar plugins de fuentes no confiables puede plantear riesgos de seguridad.",
    "pluginRisksInuserFriendly": {
        "eval": "Evaluando Código desde Cadenas",
        "globalAccess": "Accediendo a Variables Globales",
        "thisOutsideClass": "Usando 'this' Fuera del Contexto de Clase",
        "errorInVerification": "Errores Durante el Proceso de Verificación",
        "storageAccess": "Accediendo al Almacenamiento"
    },
    "pluginRisksInuserFriendlyDesc": {
        "eval": "El plugin intenta ejecutar código desde cadenas, las cadenas pueden ser ofuscadas para ocultar código malicioso.",
        "globalAccess": "El plugin intenta acceder a variables globales, lo que puede llevar a efectos secundarios no deseados o vulnerabilidades de seguridad.",
        "thisOutsideClass": "El plugin usa la palabra clave 'this' fuera del contexto de clase, lo que puede llevar a un comportamiento no deseado o problemas de seguridad.",
        "errorInVerification": "Hay errores durante el proceso de verificación del plugin, indicando problemas potenciales con su funcionalidad.",
        "storageAccess": "El plugin intenta acceder al almacenamiento, lo que podría llevar a fugas de datos o manipulación de datos no autorizada."
    },
    "generatedByAIDisclaimer": "Este contenido fue generado por IA y puede contener inexactitudes o sesgos.",
    "aiGenerationWarning": "El contenido será generado por IA y puede contener inexactitudes o sesgos.",
    "loadMore": "Cargar más",
    "goToChat": "Ir al chat",
    "noRequestLogs": "No hay registros de solicitudes disponibles.",
    "bookmark": "Marcador",
    "duplicatePluginFoundUpdateIt": "Se encontró un plugin duplicado. ¿Desea actualizar el plugin existente?",
    "branchedText": "Este chat se ha ramificado desde {}.",
    "pluginUpdateFoundInstallIt": "Se ha encontrado una actualización del plugin. ¿Desea instalar la actualización?",
    "branch": "Rama",
    "newMessageButtonBottomLeft": "Abajo a la izquierda",
    "newMessage": "Nuevo mensaje",
    "newMessageButtonFloatingCircle": "Círculo flotante (inferior derecha)",
    "newMessageButtonBottomRight": "Abajo a la derecha",
    "newMessageButtonBottomCenter": "Centro inferior (predeterminado)",
    "autoScrollToNewMessage": "Desplazamiento automático al nuevo mensaje",
    "disableMessage": "Desactivar mensaje",
    "newMessageButtonStyle": "Estilo del botón de nuevo mensaje",
    "alwaysScrollToNewMessage": "Desplazarse siempre al nuevo mensaje (ignorar la posición de desplazamiento)",
    "newMessageButtonTopBar": "Barra superior",
    "enableScrollToActiveChar": "Activar desplazamiento al personaje activo",
    "pluginDevelopMode": "Modo de desarrollo de plugins",
    "newMessageButtonRightCenter": "Centro derecha",
    "trimStartNewChat": "Recortar mensajes de «Iniciar nuevo chat»",
    "getFullDatabaseConsent": "El plugin {} está solicitando acceso a la base de datos completa, lo que podría exponer información confidencial. ¿Desea permitir esto?",
    "fetchLogConsent": "El complemento {} está solicitando obtener registros, lo cual podría exponer información confidencial. ¿Desea permitir esto?",
    "disableAbove": "Mensajes cortados para la IA",
    "hamburgerButtonBottom": "Mover el botón de menú a la parte inferior de la barra lateral",
    "nanoGPTLoadingAccountInfo": "Cargando información de la cuenta…",
    "nanoGPTCreditBalance": "Saldo de crédito:",
    "nanoGPTSubscription": "Suscripción",
    "nanoGPTGraceUntil": (date: string) => `hasta ${date}`,
    "nanoGPTNoActiveSubscription": "Sin suscripción activa.",
    "nanoGPTCancelsAtPeriodEnd": (date: string) => `Se cancela al final del período (${date})`,
    "nanoGPTWeeklyTokens": (pct: string) => `Tokens de entrada incluidos semanales — ${pct} usados`,
    "nanoGPTDailyTokens": (pct: string) => `Tokens de entrada incluidos diarios — ${pct} usados`,
    "nanoGPTDailyImages": (pct: string) => `Imágenes incluidas diarias — ${pct} usadas`,
    "nanoGPTResets": (date: string) => `Se restablece el ${date}`,
    "nanoGPTUsed": (n: string) => `${n} usados`,
    "nanoGPTRemaining": (n: string) => `${n} restantes`,
    "nanoGPTRenews": (date: string) => `Se renueva: ${date}`,
    "nanoGPTCouldNotLoadAccountInfo": "No se pudo cargar la información de la cuenta.",
    "nanoGPTWeeklyTokensLabel": "Tokens de entrada semanales incluidos",
    "nanoGPTDailyTokensLabel": "Tokens de entrada diarios incluidos",
    "nanoGPTDailyImagesLabel": "Imágenes diarias incluidas",
    "nanoGPTUsedLabel": "usados",
    "nanoGPTRemainingLabel": "restantes",
    "nanoGPTResetsLabel": "Se reinicia",
    "nanoGPTRenewsLabel": "Renovación:",
    "nanoGPTProvider": "Proveedor",
    "nanoGPTProviderPayAsYouGoOnly": "(solo disponible en modo de pago por uso)",
    "nanoGPTProviderAuto": "Auto",
    "nanoGPTProviderFree": "Gratis",
    "nanoGPTProviderInput": "Entrada",
    "nanoGPTProviderOutput": "Salida",
    "nanoGPTProviderQuantization": "Cuantización",
    "nanoGPTProviderUndisclosed": "No revelado",
    "nanoGPTProviderCache": "Caché",
    "nanoGPTProviderCacheSupported": "Compatible",
    "nanoGPTProviderCacheNotSupported": "No compatible",
    "nanoGPTProviderCacheRead": "Lectura de caché",
    "nanoGPTUseSubscriptionEndpoint": "Usar endpoint y modelos de suscripción",
    "modelGridCouldNotLoad": "No se pudo cargar la lista de modelos. Verifique su clave API.",
    "modelGridNoModelsMatch": (q: string) => `Ningún modelo coincide con "${q}"`,
    "modelGridContext": (n: string) => `Contexto: ${n}`,

    nanoGPTSelectFromList: "Seleccionar de la lista",
    nanoGPTManualInput: "Entrada manual",
    nanoGPTManualModelSelect: "Selección manual de modelo",
} satisfies DeepPartial<typeof import('./en').languageEnglish>;
